// Add this file to assets folder
// Add code {{ "bcp-locales.js" | asset_url | script_tag }} after <body> tag

if (window.BSS_BCP) {
	BSS_BCP.locales = {
		en: {
            "b2b_customer_portal": "B2B Customer Portal",
            "error_message": "Product(s) above is/are not eligible for Quote. They will be removed if you click the \"Add to quote\" button.",
            "go_to_cart": "Go to cart",
            "checkout": "Checkout",
            "purchase_late": "Purchase Late",
            "quick_order": "QUICK ORDER",
            "product_list": "Product List",
            "netterm": "NET TERM/PURCHASE LATE",
            "cart_purchase": "Cart Purchase",
            "order_history": "Order History",
            "order_detail": "Order Detail",
            "add_to_cart": "Add to cart",
            "search_product_title_sku": "Search Product title, SKU",
            "added_msg": "item(s) is added to cart",
            "contact_msg": "Please contact the store owner: Your account is not allowed for quick order.",
            "failed_msg": "Failed to find product(s)",
            "available_qty": "Available qty",
            "qty": "qty",
            "product_title": "Product title",
            "price": "Price",
            "total_record": "Total Record",
            "sku": "SKU",
            "all": "All",
            "sort_by": "Sort by",
            "name_az": "Name A-Z",
            "name_za": "Name Z-A",
            "newest_created_date": "Newest Created Date",
            "oldest_created_date": "Oldest Created Date",
            "newest_updated": "Newest Updated Date",
            "oldest_updated": "Oldest Updated Date",
            "inventory_quantity_lowest_to_highest": "Inventory Quantity Lowest to Highest",
            "inventory_quantity_highest_to_lowest": "Inventory Quantity Highest to Lowest",
            "popular": "Popular",
            "price_lowest_to_highest": "Price Lowest to Highest",
            "price_highest_to_lowest": "Price Highest to Lowest",
            "sku_az": "SKU A-Z",
            "sku_za": "SKU Z-A",
            "selected_item": "selected item(s)",
            "no_items": "No items in cart",
            "login": "LOGIN",
            "email": "Email",
            "password": "Password",
            "signin": "Sign in",
            "logout": "Log out",
            "open_sidebar": "Open sidebar",
            "close_sidebar": "Close sidebar",
            "go_to_page": "Go to page",
            "return_store": "Return to store",
            "forgot": "Forgot your password?",
            "create": "Create an account",
            "contact_information": "CONTACT INFORMATION",
            "log_out": "Log out",
            "shipping_address": "Shipping Address",
            "new_address": "Use a new address",
            "first_name": "First name (optional)",
            "last_name": "Last name",
            "company": "Company (optional)",
            "address": "Address",
            "billing_address": "Billing Address",
            "apartment": "Apartment, suit, etc. (optional)",
            "city": "City",
            "postal_code": "Postal code",
            "required": "This field is required",
            "invalidEmail": "Please enter a valid email",
            "alert": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO PURCHASE LATE.",
            "due_on": "Your payment is due on",
            "additional_information": "ADDITIONAL INFORMATION",
            "nt_valid_eu_vat": "VALID EU VAT NUMBER",
            "nt_valid_abn": "VALID ABN NUMBER",
            "nt_valid_gst": "VALID INDIA GST NUMBER",
            "nt_valid_uk": "VALID UK VAT NUMBER",
            "nt_invalid_eu_vat": "EU VAT is not valid. Please re-enter",
            "nt_invalid_abn": "ABN is not valid. Please re-enter",
            "nt_invalid_gst": "GST number is not valid. Please re-enter",
            "nt_invalid_uk": "UK VAT Registration number is not valid. Please re-enter",
            "nt_invalid_postal_code": "Enter a valid ZIP/ postal code",
            "nt_uploading_video": "It takes 30s to upload video, please wait.",
            "purchase_late_note": "PURCHASE LATE NOTE",
            "purchase_late_message": "Product(s) above is/are not eligible for Purchase Late. They will be removed if you click the Purchase Late button.",
            "purchase_late_link": "Proceed to purchase late page",
            "purchase_late_link_login": "Proceed to account login/register page",
            "purchase_late_message_qualify": "You haven&apos;t been qualified to use this payment terms. Please contact us for more details.",
            "purchase_late_message_login": "Please login or register account to purchase late these items",
            "nt_out_of_stock_title": "Out of stock",
            "nt_out_of_stock_describe": "Some items are no longer available. Your cart has been updated.",
            "nt_remove": "Remove",
            "nt_return_to_cart": "Return to cart",
            "nt_return_to_order_history": "Return to Order History",
            "nt_continue": "Continue",
            "nt_out_of_stock_sold_out": "Sold out",
            "nt_edit": "Edit",
            "nt_cancel": "Cancel",
            "nt_save": "Save",
            "nt_stay": "Stay",
            "nt_save_to_calculate": "Save to calculate",
            "nt_checkout_unsaved_changes": "Checkout with unsaved changes?",
            "nt_checkout_saving_current_edits": "If you click Checkout, you will proceed to checkout your previous cart without saving current edits.",
            "nt_continue_shipping": "Continue to shipping with unsaved changes?",
            "nt_shipping_saving_current_edits": "If you click Continue to shipping, you will proceed with your previous cart without saving current edits.",
            "nt_empty_cart": "Your cart is empty",
            "use_ship_address_as_bill_address": "Use Shipping address as Billing address",
            "ot_name": "Name",
            "ot_email": "Email",
            "ot_shipping": "Shipping",
            "ot_rule": "Rule",
            "ot_date": "Order Date",
            "ot_netterms": "Net Terms",
            "ot_remaining_days": "Remaining Days",
            "ot_days": "day(s)",
            "dashboard": "Dashboard",
            "cp_checkout": "Checkout",
            "cp_shipping": "Continue to shipping",
            "cp_tax": "Continue to tax",
            "cp_email": "Email",
            "cp_change": "Change",
            "pl_cart_product": "PRODUCT",
            "restrict_value_greater": "Your cart's total value must be greater than or equal to {{value}}",
            "restrict_value_less": "Your cart's total value must be less than or equal to {{value}}",
            "restrict_quantity_greater": "The quantity of items in your cart must be greater than or equal to {{value}}",
            "restrict_quantity_less": "The quantity of items in your cart must be less than or equal to {{value}}",
            "order_detail_no_detail": "Fail getting order detail",
            "pl_cart_subtotal": "Subtotal",
            "pl_cart_sku": "SKU",
            "pl_cart_price": "PRICE",
            "pl_cart_quantity": "QUANTITY",
            "pl_cart_shipping": "Shipping",
            "pl_cart_taxes": "Taxes",
            "pl_cart_total": "Total",
            "pl_cart_free": "Free",
            "pl_cart_taxes_included": "Including {{price}} in taxes",
            "pl_shipping_contact": "Contact",
            "pl_shipping_shipto": "Ship to",
            "pl_billing": "Billing",
            "pl_shipping_method": "SHIPPING METHOD",
            "pl_shipping_error_heading": "No shipping rates found for this address.",
            "pl_shipping_error_message": "This order can't be shipped to the address you entered. Review your address to ensure that all fields have been entered correctly and try again.",
            "vo_inStock": "In Stock",
            "vo_outOfStock": "Out of stock",
            "vo_unlimited": "Unlimited",
            "vo_addToCart": "Add to Cart",
            "vo_atLeast1Item": "At least 1 item must be added to cart",
            "vo_buyItNow": "Buy It Now",
            "r4q_tab_request_for_quote": "REQUEST FOR QUOTE",
            "r4q_tab_quote_cart": "Quote Cart",
            "r4q_tab_my_quote": "My Quotes",
            "r4q_page_request_for_quote": "REQUEST FOR QUOTE",
            "r4q_page_cart_empty": "No items in your Quote cart.",
            "r4q_page_back_to_homepage": "Or {Back to Homepage}",
            "r4q_page_add_cart_to_quote": "ADD CART ITEMS TO QUOTE",
            "r4q_message_no_item_in_cart": "No items in your cart. Please select products or add products to cart.",
            "r4q_message_products_in_cart": "Products in your cart are not eligible for Quote. Please select other products.",
            "r4q_page_product": "Product",
            "r4q_page_price": "Price",
            "r4q_page_quantity": "Quantity",
            "r4q_form_title": "Contact Information",
            "r4q_form_subtitle": "In order to reach out to you we would like to know a bit more about you",
            "r4q_page_name": "Name",
            "r4q_page_email": "Email",
            "r4q_page_message": "Message",
            "r4q_page_address_country": "Country",
            "r4q_page_address_first_name": "First name",
            "r4q_page_address_last_name": "Last name",
            "r4q_page_address_company": "Company",
            "r4q_page_address_address1": "Address",
            "r4q_page_address_address2": "Apartment, suit, etc.",
            "r4q_page_address_city": "City",
            "r4q_page_address_phone": "Phone",
            "r4q_page_submit_request": "SUBMIT REQUEST",
            "r4q_page_thank": "THANKS!",
            "r4q_page_thank_for_quote": "THANK YOU FOR YOUR QUOTE!",
            "r4q_page_enter_offer_price": "Enter offer price",
            "r4q_page_confirm_quote": "Request Confirmation",
            "r4q_page_offer_price": "Offer price",
            "r4q_quote_table_title": "Product Review",
            "r4q_quote_table_subtitle": "The following products will be added to your quote request",
            "r4q_quote_table_id": "ID",
            "r4q_quote_table_created_at": "CREATE AT",
            "r4q_quote_table_quantity_of_items": "ITEM",
            "r4q_quote_table_subtotal": "SUBTOTAL",
            "r4q_quote_table_status": "STATUS",
            "r4q_quote_table_status_converted": "CONVERTED",
            "r4q_quote_table_status_open": "OPEN",
            "r4q_quote_table_action": "ACTION",
            "r4q_quote_table_showing": "Showing",
            "r4q_quote_table_quote": "quote(s)",
            "r4q_quote_view_back_to_my_quotes": "Back to My Quotes",
            "r4q_quote_view_quote": "Quote #",
            "r4q_quote_view_quote_date": "Create at",
            "r4q_quote_view_quote_total": "Total",
            "r4q_quote_view_quote_subtotal": "Subtotal",
            "r4q_quote_view_quote_shipping": "Shipping Fee",
            "r4q_quote_view_quote_tax": "Tax",
            "r4q_quote_view_created_at": "Created at",
            "r4q_quote_view_additional_details": "Additional details",
            "r4q_quote_view_form_additional_information": "Additional Information",
            "r4q_quote_view_address": "Shipping & Billing Addresses",
            "r4q_quote_view_estimated_total": "Estimated Total",
            "r4q_quote_view_shipping_address": "Shipping Addresses",
            "r4q_quote_view_billing_address": "Billing Addresses",
            "r4q_quote_view_items": "Items",
            "r4q_quote_view_items_detail": "items",
            "r4q_quote_view_image": "IMAGE",
            "r4q_quote_view_product": "PRODUCT",
            "r4q_quote_view_quantity": "QUANTITY",
            "r4q_quote_view_request_form": "Request Form",
            "r4q_page_quoted_price": "QUOTED PRICE",
            "r4q_page_amount": "AMOUNT",
            "r4q_approx_amount": "Approx.",
            "r4q_error_field_required": "This field is required",
            "r4q_error_invalid_email": "Invalid email",
            "r4q_message_contact_msg": "Please contact the store owner: Your account is not allowed to request a quote.",
            "add_to_quote": "Add to quote",
            "the_product": "The product",
            "added_to_quote": "is added to quote",
            "products_in_quote": "Current products in quote",
            "quote_table_image": "Image",
            "quote_table_product": "Product",
            "quote_table_quantity": "Quantity",
            "continue_shopping": "CONTINUE SHOPPING",
            "view_quote": "VIEW REQUEST",
            "r4q_message_items_not_allowed_to_quote": "The product(s) above is/are not eligible for Request a quote. They will be removed if you click the Add to quote button.",
            "r4q_page_process_to_quote_page": "Proceed to Add to quote page",
            "r4q_message_all_item_invalid": "These items are not eligible for checkout. Please add them to quote.",
            "r4q_page_add_other_to_quote": "Add others to quote",
            "r4q_page_cancel_btn": "Cancel",
            "r4q_page_view_information": "Additional Information",
            "r4q_page_previous": "Previous",
            "r4q_page_next": "Next",
            "r4q_page_process_to_checkout_page": "Proceed to checkout page",
            "r4q_page_invalid_product_to_quote": "Invalid products to quote",
            "r4q_page_product_not_allowed": "These following products are not allowed to quote:",
            "r4q_message_items_invalid_checkout": "Some items are not eligible for checkout. They will be remove if you click the Checkout button. Please add these items to quote.",
            "r4q_message_quote_note_title": "REQUEST FOR QUOTE NOTE",
            "r4q_message_quote_available": "Quote Available",
            "r4q_no_data_provided": "No {{label}} provided",
            "ro": {
                "re_order_text": "RE ORDER",
                "re_order_button": "Reorder",
                "review_order": "View Order",
                "submit_option": "Save",
                "order_list": "Previous Order List",
                "contact_msg_ro": "Please contact the store owner: Your account is not allowed for reorder.",
                "title_options": "If you have products in your cart:",
                "text_option_delete_and_update_cart": "Remove those products and add reordered ones to cart.",
                "text_option_update_cart": "Keep those products and add reordered products to cart.",
                "remove_button": "Remove",
                "selected_item_button": "selected item(s)",
                "id_header": "ID",
                "order_date_header": "ORDER DATE",
                "total_quantity_header": "TOTAL QUANTITY",
                "within_day_header": "",
                "all_orders_header": "All orders",
                "within_7_days_header": "Within 7 days",
                "within_15_days_header": "Within 15 days",
                "within_1_month_header": "Within 1 month",
                "within_2_months_header": "Within 2 months",
                "within_3_months_header": "Within 3 months",
                "within_6_months_header": "Within 6 months",
                "within_1_year_header": "Within 1 year",
                "number_per_page_header": "{{number per page}} per page",
                "sort_by": "Sort by",
                "date": "Date",
                "quantity": "Quantity",
                "subtotal": "Subtotal",
                "newest_to_oldest": "Newest to oldest",
                "oldest_to_newest": "Oldest to newest",
                "highest_to_lowest": "Highest to lowest",
                "lowest_to_highest": "Lowest to highest",
                "date_header": "Date",
                "no_of_product_header": "No of products",
                "previous_order_qty_header": "Previous Order qty",
                "image_header": "Image",
                "product_header": "Product Name",
                "sku_header": "SKU",
                "qty_default_header": "Qty default",
                "total_header": "Total",
                "edit_qty_header": "Edit Qty",
                "select_all_header": "Select All",
                "order_not_found_msg": "Order not found!",
                "text_option": "Options",
                "text_click_to_add_item": "Click \"Reorder\" to add all items from the previous order to your shopping cart. Click \"View order\" to review and update quantities for the previous order.",
                "text_note_display_product_price": "Noted: This order displays product price (excluded tax & shipping fee) from the past. The present price could be changed. Please add to cart or update quantity to see the new price!",
                "favorite_order": "Favorite orders",
                "ro_undo_button": "Undo",
                "order_mark_as_favorite_msg": "Marked as favorite",
                "order_remove_from_favorite_msg": "Removed from Favorite orders",
                "remove_from_favorite_button": "Remove from Favorite Orders",
                "ordered_at": "Order at",
                "total": "Total",
                "items_selected": "items selected",
                "ro_add_to_cart": "Add to cart",
                "ro_button_reset": "Reset",
                "ro_button_cancel": "Cancel",
                "ro_reorder_all": "Reorder All",
                "toast_view_cart": "View cart",
                "toast_message": "{{quantity}} item(s) added to cart"
            },
            "mo_my_orders": "My orders",
            "mo_search": "Search by #Order or SKU",
            "mo_order_details": "Order details",
            "mo_items": "Item(s)",
            "mo_cart": "Cart",
            "mo_go_to_cart": "Go to cart",
            "mo_order_view_cart_button": "{{item}} item(s), {{quantity}} quantity(ies)",
            "mo_order": "Order",
            "mo_date": "Date",
            "mo_payment_status": "Payment status",
            "mo_fulfillment_status": "Fulfillment status",
            "mo_total": "Total",
            "mo_no_orders": "No orders found",
            "mo_no_items": "You have no items in your cart!",
            "mo_reorder": "Reorder",
            "mo_order_detail_header": "Order {{order_name}} detail",
            "mo_order_detail_back": "Back to my orders",
            "mo_order_detail_no_detail": "Fail getting order detail",
            "mo_order_partially_added": "Orders partially paid",
            "mo_order_partially_added_items_not_added": "Some items in this order have not been added to your cart",
            "mo_order_partially_added_not_available": "These items are no longer available",
            "mo_order_partially_added_out_of_stock": "These items are not currently in stock",
            "mo_order_partially_added_cancel": "Stay on this page",
            "mo_order_partially_added_add_to_reorder": "Add to Reorder Cart",
            "mo_order_detail_order_information": "Order information",
            "mo_order_detail_order_date": "Order date",
            "mo_order_detail_payment_status": "Payment status",
            "mo_order_detail_fulfillment_status": "Fulfillment status",
            "mo_order_detail_product": "Product",
            "mo_order_detail_price": "Price",
            "mo_order_detail_quantity": "Quantity",
            "mo_order_detail_product_total": "Total",
            "mo_order_detail_billing_address": "Billing address",
            "mo_order_detail_shipping_address": "Shipping address",
            "mo_order_detail_payment": "Payment",
            "mo_order_detail_subtotal": "Subtotal",
            "mo_order_detail_shipping": "Shipping",
            "mo_order_detail_total": "Total",
            "mo_order_detail_export_order": "Export order",
            "mo_order_detail_export_primary_action": "Export",
            "mo_order_detail_export_secondary_action": "Cancel",
            "mo_status_paid": "PAID",
            "mo_status_partially_paid": "PARTIALLY PAID",
            "mo_status_pending": "PENDING",
            "mo_status_fulfilled": "FULFILLED",
            "mo_status_partially_fulfilled": "PARTIALLY FULFILLED",
            "mo_status_unfulfilled": "UNFULFILLED",
            "mo_status_voided": "VOIDED",
            "ca_company_tax_number": "Company tax number",
            "ca_company_phone": "Company phone",
            "ca_company_account": "COMPANY ACCOUNTS",
            "ca_company": "Company",
            "ca_company_members": "Company Members",
            "ca_company_roles": "Company Roles",
            "ca_company_orders": "Company Orders",
            "ca_my_orders": "My Orders",
            "ca_button_edit": "Edit",
            "ca_button_save": "Save",
            "ca_button_cancel": "Cancel",
            "ca_button_invite": "Invite new member",
            "ca_button_send_invite": "Send invite",
            "ca_button_see_all_invites": "See all invites sent",
            "ca_button_add_new_role": "Add new role",
            "ca_button_create_order": "Create order with items in cart",
            "ca_button_request_create_company": "Request to create company",
            "ca_button_send_request": "Send request",
            "ca_button_resend_request": "Resend request",
            "ca_button_remove": "Remove",
            "ca_button_close": "Close",
            "ca_button_go_to_company": "Go to Company",
            "ca_button_delete": "Delete",
            "ca_button_go_to_company_members": "Go to Company members",
            "ca_button_next": "Next",
            "ca_button_prev": "Prev",
            "ca_button_confirm": "Confirm",
            "ca_button_confirm_payment": "Confirm Payment",
            "ca_apply_to_cart": "Apply Order To Cart",
            "ca_mark_as_paid": "Mark as Paid",
            "ca_button_share_cart": "Share Cart",
            "ca_name_can_not_be_empty": "Name can not be empty",
            "ca_invalid_email": "Invalid Email",
            "ca_invalid_email_format": "Invalid email format",
            "ca_role_name_not_empty": "Role name can not be empty",
            "ca_first_name_not_empty": "First name can not be empty",
            "ca_last_name_not_empty": "Last name can not be empty",
            "ca_request_review": "Your request is being under review, please wait for approval",
            "ca_request_sent": "Request sent",
            "ca_request_rejected": "Your request was rejected, resend request or contact store owner for more information",
            "ca_company_disabled": "Your company was disabled, contact store owner for more information",
            "ca_sure_to_remove_member": "Are you sure to remove this member out of the company? This can't be undone",
            "ca_change_role_members": "There are several members having this role. To delete this role, you have to change members' roles or remove members first",
            "ca_sure_delete_role": "Are you sure to delete this role? This can't be undone",
            "ca_order_deleted": "Order deleted",
            "ca_company_role_deleted": "Company role deleted",
            "ca_company_role_added": "Company role added",
            "ca_items_added_to_cart": "Items added to cart, go to Cart page to checkout!",
            "ca_order_status_changed": "Order status changed to Paid!",
            "ca_company_role_updated": "Company role updated",
            "ca_company_information_saved": "Company information saved",
            "ca_invites_sent": "Invites sent to <<member's email>> successfully!",
            "ca_access_denied": "Access denied",
            "ca_permission_access": "You do not have permission to access this page",
            "ca_not_in_company": "You are not in any company",
            "ca_you_can": "You can",
            "ca_create_company": "Create a company",
            "ca_accept_below": "or accept below joining invites",
            "ca_first_time_use": "This is first time you use Company Accounts. Please confirm some information",
            "ca_request_approved": "Request approved, you are a member of the company now!",
            "ca_member_infor_saved": "Member information saved!",
            "ca_member_removed": "Member removed",
            "ca_edit_user": "Edit user",
            "ca_manager_protect": "Manager Protect",
            "ca_view_order_details": "View Order Details",
            "ca_delete_user": "Delete user",
            "ca_invalid_form": "Invalid Form",
            "ca_your_information_confirmed": "Your information confirmed",
            "ca_invite_removed": "Invite removed",
            "ca_max_length_characters": "Maximum length is 100 characters",
            "ca_request_create_company": "Request to create company",
            "ca_company_information": "Company Information",
            "ca_company_name": "Company Name",
            "ca_company_email": "Company Email",
            "ca_manager_email": "Manager Email",
            "ca_manager": "Manager",
            "ca_address": "Address",
            "ca_company_address": "Company Address",
            "ca_your_information": "Your information",
            "ca_edit_company_profile": "Edit company profile",
            "ca_user_infor": "User Infor",
            "ca_first_name": "First name",
            "ca_last_name": "Last name",
            "ca_email_user": "Email",
            "ca_company_status": "Status",
            "ca_company_role": "Role",
            "ca_company_action": "Action",
            "ca_company_pending": "Pending",
            "ca_company_accept": "Accept",
            "ca_company_reject": "Reject",
            "ca_company_default": "Default",
            "ca_page_company_members": "Company Members",
            "ca_invalid_member": "Invite member",
            "ca_edit_member": "Edit member",
            "ca_remove_member": "Remove member",
            "ca_all_invites_sent": "All invites sent",
            "ca_name": "Name",
            "ca_role": "Role",
            "ca_manager_members": "Manager",
            "ca_default": "Default",
            "ca_email": "Email",
            "ca_member_email": "Member's email",
            "ca_action": "Action",
            "ca_created_at": "Created At",
            "ca_status": "Status",
            "ca_pending": "Pending",
            "ca_approved": "Accept",
            "ca_canceled": "Cancel",
            "ca_rejected": "Reject",
            "ca_undefined": "Undefined",
            "ca_member_address": "Address",
            "ca_roles": "Company Roles",
            "ca_create_new_role": "Create new role",
            "ca_edit_role": "Edit role",
            "ca_delete_role": "Delete role",
            "ca_cannot_edit": "Can't delete",
            "ca_role_name": "Role name",
            "ca_related_members": "Related members",
            "ca_permissions": "Permissions",
            "ca_action_roles": "Action",
            "ca_manage_company_orders": "Manage company orders",
            "ca_manage_roles": "Manage roles",
            "ca_manage_members": "Manage members",
            "ca_members_can_create_company_orders": "By default, all members can create company orders",
            "ca_orders": "Company Orders",
            "ca_my_orders_page": "My Orders",
            "ca_id": "ID",
            "ca_created_at_order": "Created At",
            "ca_order_name": "Name",
            "ca_order_by": "Ordered By",
            "ca_status_order": "Payment Status",
            "ca_paid_order": "Paid",
            "ca_not_paid_order": "Not paid",
            "ca_subtotal_order": "Subtotal",
            "ca_note_order": "Note",
            "ca_action_order": "Action",
            "ca_order_details": "Order details",
            "ca_items_order": "Items",
            "ca_estimated_subtotal": "Estimated subtotal",
            "ca_paid_by": "Paid by",
            "ca_confirm_payment_status": "Confirm Payment Status",
            "ca_confirm_payment_content": "Confirm Payment Status",
            "ca_product": "Product",
            "ca_title_share_company": "Title",
            "ca_total_share_company": "Total",
            "ca_subtotal_share_company": "Subtotal",
            "ca_clear_my_cart": "Clear my cart after sharing",
            "ca_your_cart": "Your cart",
            "ca_share_your_cart": "Share your cart to company",
            "ca_note_share_company": "Note",
            "ca_your_cart_empty_share_company": "Your Cart is Empty",
            "ca_appear_cart_after_sharing": "After sharing, your cart will appear at Company order as an order",
            "sr_please_contact_the_store_owner": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO USE SALE REP.",
            "sr_sales_rep": "SALES REP",
            "sr_sales_rep_home": "Sales Rep Home",
            "sr_coupon": "Coupon",
            "sr_create_invoice": "Create Invoice",
            "sr_manage_customers": "Manage Customers",
            "sr_manage_orders": "Manage Orders",
            "sr_btn_create_customer": "Create customer",
            "sr_btn_preview_and_send_invoice": "Preview invoice",
            "sr_btn_preview_and_send_order": "Create order",
            "sr_btn_add_to_order": "Add to order",
            "sr_btn_view_options": "View Options",
            "sr_btn_preview_order": "Preview order",
            "sr_btn_preview_order_items": "items",
            "sr_btn_preview_order_quantities": "quantities",
            "sr_added_to_order": "Added to order",
            "sr_home_dashboard_text": "Dashboard",
            "sr_home_sales_current_month_text": "Sales Performance Current Month",
            "sr_home_sales_by_filter_text": "Sales Performance by filter",
            "sr_home_one_month_text": "1 Month",
            "sr_home_three_months_text": "3 Months",
            "sr_home_six_months_text": "6 Months",
            "sr_home_nine_months_text": "9 Months",
            "sr_home_twelve_months_text": "12 Months",
            "sr_home_total_orders_text": "Total orders",
            "sr_home_commission_text": "Commission",
            "sr_home_sales_text": "Sales",
            "sr_my_customers": "My Customers",
            "sr_share_your_discount_coupon_code": "Share your Discount Coupon Code to customer!",
            "sr_your_coupon_code": "Your coupon code:",
            "sr_discount_amount": "Discount amount:",
            "sr_commission_rate": "Commission rate:",
            "sr_based_on_specific_product": "Based on specific product",
            "sr_mark_order_with_customers": "Mark order with customer",
            "sr_mark_with_customers": "Mark with Customer",
            "sr_customers_title_create": "Create Customer",
            "sr_customers_drop_down_created_at": "Created at",
            "sr_customers_all": "All",
            "sr_customers_last_seven_days": "Last 7 days",
            "sr_customers_last_thirty_days": "Last 30 days",
            "sr_customers_last_ninety_days": "Last 90 days",
            "sr_customers_last_twelve_months": "Last 12 months",
            "sr_customers_my_customers": "My Customers",
            "sr_customers_enter_customer_email": "Enter customer email",
            "sr_customers_no": "NO.",
            "sr_customers_id": "CUSTOMER ID",
            "sr_customers_name": "NAME",
            "sr_customers_email_table_text": "EMAIL",
            "sr_customers_total_commission": "TOTAL COMMISSION",
            "sr_customers_created_on": "CREATED ON",
            "sr_customers_actions": "ACTIONS",
            "sr_customer_overview": "Customer Overview",
            "sr_customers_first_name": "First name",
            "sr_customers_last_name": "Last name",
            "sr_customers_email": "Email",
            "sr_customers_create_phone_number": "Phone number",
            "sr_customers_agreed_emails": "Customer agreed to receive marketing emails.",
            "sr_customers_agreed_receive_SMS": "Customer agreed to receive SMS marketing text messages.",
            "sr_customers_permission_notice": "You should ask your customers for permission before you subscribe them to your marketing emails or SMS.",
            "sr_customers_customer_address": "Customer Address",
            "sr_customers_country_region": "Country/Region",
            "sr_customers_company": "Company",
            "sr_customers_address": "Address",
            "sr_customers_apartment_suite_etc": "Apartment, suite, etc.",
            "sr_customers_city": "City",
            "sr_customers_postal_code": "Postal code",
            "sr_customers_phone_number": "Phone number",
            "sr_customers_customer_note": "Customer Note",
            "sr_customers_note": "Note",
            "sr_customers_checkout_notice": "*If a customer checkout with one of these emails, the order will be marked as your order (no need to login)",
            "sr_customers_customer": "Customer",
            "sr_customers_email_lowercase": "Email",
            "sr_customers_created_at": "Created at",
            "sr_customers_amount_spent": "Amount spent",
            "sr_customers_total_orders": "Total orders",
            "sr_customers_status": "Status",
            "sr_customers_enabled_uppercase": "ENABLED",
            "sr_customers_disabled_uppercase": "DISABLED",
            "sr_customers_declined_uppercase": "DECLINED",
            "sr_customers_invited_uppercase": "INVITED",
            "sr_customers_tags": "Tags",
            "sr_customers_order": "ORDER",
            "sr_customers_date": "DATE",
            "sr_customers_payment": "PAYMENT",
            "sr_customers_fulfillment": "FULFILLMENT",
            "sr_customers_subtotal": "SUBTOTAL",
            "sr_customers_commission": "COMMISSION",
            "sr_customers_tax": "TAX",
            "sr_customers_total": "TOTAL",
            "sr_invoice_create_invoice_title": "Create Invoice",
            "sr_customer_info": "CUSTOMER INFO",
            "sr_invoice_all": "All",
            "sr_invoice_last_name_required": "Last name is required",
            "sr_invoice_city_required": "City is required",
            "sr_invoice_address_required": "Address is required",
            "sr_invoice_country_required": "Country is required",
            "sr_invoice_please_select_customer": "Please select customer to create invoice",
            "sr_invoice_customer": "List Customer",
            "sr_invoice_email": "Email",
            "sr_invoice_create_address": "Address",
            "sr_invoice_select_customer": "Select Customer",
            "sr_invoice_customer_email": "Customer Email",
            "sr_invoice_customer_address": "Customer address",
            "sr_invoice_shipping_address": "Shipping address",
            "sr_invoice_hide_shipping_address": "Hide shipping address",
            "sr_invoice_show_shipping_address": "Show shipping address",
            "sr_invoice_edit_shipping_address": "Edit shipping address",
            "sr_invoice_first_name": "First name",
            "sr_invoice_last_name": "Last name",
            "sr_invoice_address": "Address",
            "sr_invoice_company": "Company",
            "sr_invoice_apartment_suite_etc": "Apartment, suit, etc.",
            "sr_invoice_city": "City",
            "sr_invoice_country": "Country",
            "sr_invoice_postal_code": "Postal code",
            "sr_invoice_product_list": "PRODUCT LIST",
            "sr_invoice_add_note": "Add note",
            "sr_no_items_in_order": "No item in order",
            "sr_invoice_note_to_the_order": "Note to the order",
            "sr_invoice_select_products": "Select products",
            "sr_invoice_search_product_title_SKU": "Search product title, SKU",
            "sr_invoice_total_record": "Total Record",
            "sr_invoice_subtotal": "Subtotal",
            "sr_invoice_send_invoice": "Send invoice",
            "sr_invoice_cancel": "Cancel",
            "sr_invoice_from": "From:",
            "sr_invoice_to": "To:",
            "sr_invoice_subject": "Subject:",
            "sr_invoice_success": "Success",
            "sr_invoice_send_invoice_successfully": "Send invoice successfully",
            "sr_invoice_send_invoice_failed": "Send invoice failed",
            "sr_invoice_send_order_successfully": "Send order successfully",
            "sr_invoice_in_stock": "In Stock",
            "sr_invoice_out_of_stock": "Out Of Stock",
            "sr_invoice_volume_pricing_available": "Volume pricing available",
            "sr_invoice_SKU": "SKU",
            "sr_invoice_commission": "Commission",
            "sr_invoice_shipping_address_updated": "Shipping address updated",
            "sr_invoice_qty": "qty",
            "sr_orders_my_orders": "My Orders",
            "sr_orders_all_orders": "All orders",
            "sr_orders_orders": "Orders",
            "sr_orders_draft_orders": "Draft Orders",
            "sr_orders_order": "ORDER",
            "sr_orders_order_date": "ORDER DATE",
            "sr_orders_customer": "CUSTOMER",
            "sr_orders_status": "STATUS",
            "sr_orders_tracking_number": "TRACKING NUMBER",
            "sr_draft_order_open": "OPEN",
            "sr_draft_order_invoice_sent": "INVOICE_SENT",
            "sr_orders_table_subtotal": "TOTAL",
            "sr_orders_commission": "COMMISSION",
            "sr_orders_action": "ACTION",
            "sr_orders_invoice": "INVOICE",
            "sr_orders_select_customer": "Select Customer",
            "sr_orders_order_info_customer": "Customer",
            "sr_orders_not_selected": "Not selected",
            "sr_orders_created_by": "Created by",
            "sr_orders_payment_status": "Payment status",
            "sr_orders_payment_paid": "PAID",
            "sr_orders_payment_pending": "PENDING",
            "sr_orders_fulfillment_status": "Fulfillment Status",
            "sr_orders_unfulfilled": "UNFULFILLED",
            "sr_orders_fulfilled": "FULFILLED",
            "sr_orders_created_at": "Create at",
            "sr_orders_commission_rate": "Commission rate",
            "sr_orders_tags": "Tags",
            "sr_orders_tracking_number_view": "Tracking number",
            "sr_orders_subtotal": "Subtotal",
            "sr_orders_discount": "Discount",
            "sr_orders_tax": "Tax",
            "sr_orders_shipping": "Shipping",
            "sr_orders_total": "Total",
            "sr_orders_no_preview_title": "There is no preview for order confirmation email. Once sent, you will not be able to make change to the email.",
            "sr_orders_no_preview_subtitle_1": "We suggest you  send a test email first.",
            "sr_orders_no_preview_subtitle_2": "Do you wish to continue?",
            "info_heading": "INFORMATION",
            "info_personal_title": "Personal information",
            "info_personal_information_heading": "My information",
            "info_personal_b2b_information_heading": "B2B information",
            "info_personal_password_heading": "Change my password",
            "info_personal_address_heading": "Addresses",
            "info_personal_first_name_label": "First name",
            "info_personal_last_name_label": "Last name",
            "info_personal_email_label": "Email",
            "info_personal_email_consent_label": "Email me with news and offers",
            "info_personal_password_label": "New password",
            "info_personal_repeated_password_label": "Repeat password",
            "info_personal_company_label": "Company",
            "info_personal_address1_label": "Address",
            "info_personal_address2_label": "Apartment, suite, etc",
            "info_personal_city_label": "City",
            "info_personal_country_label": "Country",
            "info_personal_province_label": "Province",
            "info_personal_zip_label": "Postal/Zip code",
            "info_personal_phone_label": "Phone",
            "info_personal_default_address_label": "Set as default address",
            "info_personal_email_empty": "Email is required",
            "info_personal_email_invalid": "Email is invalid",
            "info_personal_password_empty": "Password is required",
            "info_personal_password_short": "Password must be at least 5 characters",
            "info_personal_repeated_password_empty": "Repeated password is required",
            "info_personal_repeated_password_unmatched": "Repeated password do not match",
            "info_personal_save_info": "Save details",
            "info_personal_save_password": "Save password",
            "info_personal_update_address": "Update address",
            "info_personal_add_address": "Add address",
            "info_personal_default_address": "Default address",
            "info_personal_delete_address": "Delete address",
            "info_personal_delete_address_content": "This can't be undone",
            "info_personal_phone_invalid": "Phone number is invalid",
            "info_personal_cancel": "Cancel",
            "info_personal_edit": "Edit",
            "info_personal_delete": "Delete",
            "info_orders_title": "My orders",
            "nt": {
                "netterm": "NET TERM/PURCHASE LATE",
                "cart_purchase": "Cart Purchase",
                "order_history": "Order History",
                "order_detail": "Order Detail",
                "purchase_late": "Purchase Late",
                "no_items": "No items in cart",
                "cp_checkout": "Checkout",
                "cp_shipping": "Continue to shipping",
                "cp_change": "Change",
                "nt_remove": "Remove",
                "nt_return_to_cart": "Return to cart",
                "nt_return_to_order_history": "Return to Order History",
                "nt_continue": "Continue",
                "pl_cart_subtotal": "Subtotal",
                "pl_cart_sku": "SKU",
                "pl_cart_price": "PRICE",
                "pl_cart_quantity": "QUANTITY",
                "pl_cart_shipping": "Shipping",
                "pl_cart_taxes": "Taxes",
                "pl_cart_total": "Total",
                "pl_cart_free": "Free",
                "pl_cart_taxes_included": "Including {{price}} in taxes",
                "login": "LOGIN",
                "email": "Email",
                "password": "Password",
                "signin": "Sign in",
                "return_store": "Return to store",
                "forgot": "Forgot your password?",
                "create": "Create an account",
                "contact_information": "CONTACT INFORMATION",
                "cp_email": "Email",
                "log_out": "Log out",
                "shipping_address": "SHIPPING ADDRESS",
                "billing_address": "BILLING ADDRESS",
                "use_ship_address_as_bill_address": "Use Shipping address as Billing address",
                "new_address": "Use a new address",
                "first_name": "First name (optional)",
                "last_name": "Last name",
                "company": "Company (optional)",
                "address": "Address",
                "apartment": "Apartment, suit, etc. (optional)",
                "city": "City",
                "postal_code": "Postal code",
                "personal_customs_code": "Personal Customs Code",
                "nt_cart_note": "Cart note",
                "required": "This field is required",
                "invalidEmail": "Please enter a valid email",
                "alert": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO PURCHASE LATE.",
                "errorMessage": "Fill all required field and double check all errors",
                "due_on": "Your payment is due on",
                "additional_information": "ADDITIONAL INFORMATION",
                "nt_valid_eu_vat": "VALID EU VAT NUMBER",
                "nt_valid_abn": "VALID ABN NUMBER",
                "nt_valid_gst": "VALID INDIA GST NUMBER",
                "nt_valid_uk": "VALID UK VAT NUMBER",
                "nt_invalid_eu_vat": "EU VAT is not valid. Please re-enter",
                "nt_invalid_abn": "ABN is not valid. Please re-enter",
                "nt_invalid_gst": "GST number is not valid. Please re-enter",
                "nt_invalid_uk": "UK VAT Registration number is not valid. Please re-enter",
                "nt_invalid_postal_code": "Enter a valid ZIP/ postal code",
                "pl_shipping_contact": "Contact",
                "pl_shipping_shipto": "Ship to",
                "pl_shipping_method": "SHIPPING METHOD",
                "pl_shipping_error_heading": "No shipping rates found for this address.",
                "pl_shipping_error_message": "This order can't be shipped to the address you entered. Review your address to ensure that all fields have been entered correctly and try again.",
                "purchase_late_note": "PURCHASE LATE NOTE",
                "purchase_late_message": "Product(s) above is/are not eligible for Purchase Late. They will be removed if you click the Purchase Late button.",
                "purchase_late_link": "Proceed to purchase late page",
                "nt_out_of_stock_title": "Out of stock",
                "nt_out_of_stock_describe": "Some items are no longer available. Your cart has been updated.",
                "nt_out_of_stock_sold_out": "Sold out",
                "ot_name": "Name",
                "ot_email": "Email",
                "ot_shipping": "Shipping",
                "ot_rule": "Rule",
                "ot_date": "Order Date",
                "ot_netterms": "Net Terms",
                "ot_remaining_days": "Remaining Days",
                "ot_days": "day(s)",
                "ot_hours": "hour(s)",
                "ot_due_on_receipt": "Due on receipt",
                "ot_due_on_date": "Due on specific date",
                "pl_cart_product": "PRODUCT",
                "nt_edit": "Edit",
                "nt_cancel": "Cancel",
                "nt_save": "Save",
                "nt_stay": "Stay",
                "nt_search_input": "Enter order name",
                "nt_search_btn": "Search",
                "nt_sort_by": "Sort by",
                "nt_new_to_old": "Newest to oldest",
                "nt_old_to_new": "Oldest to newest",
                "nt_a_to_z": "Name A-Z",
                "nt_z_to_a": "Name Z-A",
                "nt_short_to_long": "Net terms Shortest to Longest",
                "nt_long_to_short": "Net terms Longest to Shortest",
                "nt_remain_days_asc": "Ascending Remaining days",
                "nt_remain_days_desc": "Descending Remaining days",
                "nt_save_to_calculate": "Save to calculate",
                "nt_empty_cart": "Your cart is empty",
                "nt_checkout_unsaved_changes": "Checkout with unsaved changes?",
                "nt_checkout_saving_current_edits": "If you click Checkout, you will proceed to checkout your previous cart without saving current edits.",
                "nt_continue_shipping": "Continue to shipping with unsaved changes?",
                "nt_shipping_saving_current_edits": "If you click Continue to shipping, you will proceed with your previous cart without saving current edits.",
                "restrict_value_greater": "Your cart's total value must be greater than or equal to {{value}}",
                "restrict_value_less": "Your cart's total value must be less than or equal to {{value}}",
                "restrict_quantity_greater": "The quantity of items in your cart must be greater than or equal to {{value}}",
                "restrict_quantity_less": "The quantity of items in your cart must be less than or equal to {{value}}",
                "order_detail_no_detail": "Fail getting order detail",
                "due_on_payment": "Due on payment"
            },
            "qo": {
                "quick_order_navigation_menu": "QUICK ORDER",
                "quick_order_list": "Product List",
                "quick_order_cart": "Preview Cart",
                "go_to_cart": "Go To Cart",
                "checkout_btn": "Checkout",
                "sync_with_cart": "SYNC WITH CART",
                "sync_with_cart_banner_info": "Click 'SYNC WITH CART' to keep your Preview cart and Cart perfectly aligned. Never lose track of your items -- sync now for a smoother shopping journey!",
                "add_to_cart": "Add to cart",
                "contact_msg": "Please contact the store owner: Your account is not allowed for quick order.",
                "failed_msg": "Failed to find product(s)",
                "total_record": "Total Record",
                "sku": "SKU",
                "barcode": "Barcode",
                "subtotal": "Subtotal",
                "search_product_title_sku": "Search Product title, SKU",
                "all": "All",
                "title_az": "Title A-Z",
                "title_za": "Title Z-A",
                "newest_created_date": "Newest Created Date",
                "oldest_created_date": "Oldest Created Date",
                "inventory_quantity_lowest_to_highest": "Inventory Quantity Lowest to Highest",
                "inventory_quantity_highest_to_lowest": "Inventory Quantity Highest to Lowest",
                "price_lowest_to_highest": "Price Lowest to Highest",
                "price_highest_to_lowest": "Price Highest to Lowest",
                "qo_loading_type": "Load more",
                "end_of_list": "You've reached the end of the list.",
                "add_all": "Add {{items}} items to cart",
                "remove_all": "Remove all items",
                "sort_collection": "Collection",
                "from": "From",
                "view_option": "View options",
                "in_stock": "In Stock",
                "out_of_stock": "Out Of Stock",
                "price_cut": "PRICE CUT",
                "save_discount": "SAVE",
                "popup_added_to_cart": "Added to Cart",
                "volume_pricing_available": "Volume pricing available",
                "no_line_items_cart": "You have no items in your cart!",
                "add_to_cart_error": "Some unexpected error happened. please try again",
                "cart_items": "items",
                "cart_quantities": "quantities",
                "synced_with_cart_toast": "Synced with Cart",
                "product_types": "PRODUCT TYPES",
                "collections": "COLLECTIONS"
            }
        },
        es: {
            "b2b_customer_portal": "B2B Customer Portal",
            "error_message": "Product(s) above is/are not eligible for Quote. They will be removed if you click the \"Add to quote\" button.",
            "go_to_cart": "Go to cart",
            "checkout": "Checkout",
            "purchase_late": "Purchase Late",
            "quick_order": "COMMANDE RAPIDE",
            "product_list": "Liste de produits",
            "netterm": "NET TERM/PURCHASE LATE",
            "cart_purchase": "Cart Purchase",
            "order_history": "Order History",
            "order_detail": "Order Detail",
            "add_to_cart": "Ajouter au panier",
            "search_product_title_sku": "Search Product title, SKU",
            "added_msg": "items(s) est ajouté au panier",
            "contact_msg": "Veuillez contacter le propriétaire du magasin : votre compte n'est pas autorisé pour une commande rapide.",
            "failed_msg": "Failed to find product(s)",
            "available_qty": "Qté disponible",
            "qty": "qty",
            "product_title": "Titre du produit",
            "price": "Prix",
            "total_record": "Enregistrement total",
            "sku": "SKU",
            "all": "All",
            "sort_by": "Sort by",
            "name_az": "Name A-Z",
            "name_za": "Name Z-A",
            "newest_created_date": "Newest Created Date",
            "oldest_created_date": "Oldest Created Date",
            "newest_updated": "Newest Updated Date",
            "oldest_updated": "Oldest Updated Date",
            "inventory_quantity_lowest_to_highest": "Inventory Quantity Lowest to Highest",
            "inventory_quantity_highest_to_lowest": "Inventory Quantity Highest to Lowest",
            "popular": "Popular",
            "price_lowest_to_highest": "Price Lowest to Highest",
            "price_highest_to_lowest": "Price Highest to Lowest",
            "sku_az": "SKU A-Z",
            "sku_za": "SKU Z-A",
            "selected_item": "selected item(s)",
            "no_items": "No items in cart",
            "login": "LOGIN",
            "email": "Email",
            "password": "Password",
            "signin": "Sign in",
            "logout": "Log out",
            "open_sidebar": "Open sidebar",
            "close_sidebar": "Close sidebar",
            "go_to_page": "Go to page",
            "return_store": "Return to store",
            "forgot": "Forgot your password?",
            "create": "Create an account",
            "contact_information": "CONTACT INFORMATION",
            "log_out": "Log out",
            "shipping_address": "Shipping Address",
            "new_address": "Use a new address",
            "first_name": "First name (optional)",
            "last_name": "Last name",
            "company": "Company (optional)",
            "address": "Address",
            "billing_address": "Billing Address",
            "apartment": "Apartment, suit, etc. (optional)",
            "city": "City",
            "postal_code": "Postal code",
            "required": "This field is required",
            "invalidEmail": "Please enter a valid email",
            "alert": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO PURCHASE LATE.",
            "due_on": "Your payment is due on",
            "additional_information": "ADDITIONAL INFORMATION",
            "nt_valid_eu_vat": "VALID EU VAT NUMBER",
            "nt_valid_abn": "VALID ABN NUMBER",
            "nt_valid_gst": "VALID INDIA GST NUMBER",
            "nt_valid_uk": "VALID UK VAT NUMBER",
            "nt_invalid_eu_vat": "EU VAT is not valid. Please re-enter",
            "nt_invalid_abn": "ABN is not valid. Please re-enter",
            "nt_invalid_gst": "GST number is not valid. Please re-enter",
            "nt_invalid_uk": "UK VAT Registration number is not valid. Please re-enter",
            "nt_invalid_postal_code": "Enter a valid ZIP/ postal code",
            "nt_uploading_video": "It takes 30s to upload video, please wait.",
            "purchase_late_note": "PURCHASE LATE NOTE",
            "purchase_late_message": "Product(s) above is/are not eligible for Purchase Late. They will be removed if you click the Purchase Late button.",
            "purchase_late_link": "Proceed to purchase late page",
            "purchase_late_link_login": "Proceed to account login/register page",
            "purchase_late_message_qualify": "You haven&apos;t been qualified to use this payment terms. Please contact us for more details.",
            "purchase_late_message_login": "Please login or register account to purchase late these items",
            "nt_out_of_stock_title": "Out of stock",
            "nt_out_of_stock_describe": "Some items are no longer available. Your cart has been updated.",
            "nt_remove": "Remove",
            "nt_return_to_cart": "Return to cart",
            "nt_return_to_order_history": "Return to Order History",
            "nt_continue": "Continue",
            "nt_out_of_stock_sold_out": "Sold out",
            "nt_edit": "Edit",
            "nt_cancel": "Cancel",
            "nt_save": "Save",
            "nt_stay": "Stay",
            "nt_save_to_calculate": "Save to calculate",
            "nt_checkout_unsaved_changes": "Checkout with unsaved changes?",
            "nt_checkout_saving_current_edits": "If you click Checkout, you will proceed to checkout your previous cart without saving current edits.",
            "nt_continue_shipping": "Continue to shipping with unsaved changes?",
            "nt_shipping_saving_current_edits": "If you click Continue to shipping, you will proceed with your previous cart without saving current edits.",
            "nt_empty_cart": "Your cart is empty",
            "use_ship_address_as_bill_address": "Use Shipping address as Billing address",
            "ot_name": "Name",
            "ot_email": "Email",
            "ot_shipping": "Shipping",
            "ot_rule": "Rule",
            "ot_date": "Order Date",
            "ot_netterms": "Net Terms",
            "ot_remaining_days": "Remaining Days",
            "ot_days": "day(s)",
            "dashboard": "Dashboard",
            "cp_checkout": "Checkout",
            "cp_shipping": "Continue to shipping",
            "cp_tax": "Continue to tax",
            "cp_email": "Email",
            "cp_change": "Change",
            "pl_cart_product": "PRODUCT",
            "restrict_value_greater": "Your cart's total value must be greater than or equal to {{value}}",
            "restrict_value_less": "Your cart's total value must be less than or equal to {{value}}",
            "restrict_quantity_greater": "The quantity of items in your cart must be greater than or equal to {{value}}",
            "restrict_quantity_less": "The quantity of items in your cart must be less than or equal to {{value}}",
            "order_detail_no_detail": "Fail getting order detail",
            "pl_cart_subtotal": "Subtotal",
            "pl_cart_sku": "SKU",
            "pl_cart_price": "PRICE",
            "pl_cart_quantity": "QUANTITY",
            "pl_cart_shipping": "Shipping",
            "pl_cart_taxes": "Taxes",
            "pl_cart_total": "Total",
            "pl_cart_free": "Free",
            "pl_cart_taxes_included": "Including {{price}} in taxes",
            "pl_shipping_contact": "Contact",
            "pl_shipping_shipto": "Ship to",
            "pl_billing": "Billing",
            "pl_shipping_method": "SHIPPING METHOD",
            "pl_shipping_error_heading": "No shipping rates found for this address.",
            "pl_shipping_error_message": "This order can't be shipped to the address you entered. Review your address to ensure that all fields have been entered correctly and try again.",
            "vo_inStock": "In Stock",
            "vo_outOfStock": "Out of stock",
            "vo_unlimited": "Unlimited",
            "vo_addToCart": "Add to Cart",
            "vo_atLeast1Item": "At least 1 item must be added to cart",
            "vo_buyItNow": "Buy It Now",
            "r4q_tab_request_for_quote": "REQUEST FOR QUOTE",
            "r4q_tab_quote_cart": "Quote Cart",
            "r4q_tab_my_quote": "My Quotes",
            "r4q_page_request_for_quote": "REQUEST FOR QUOTE",
            "r4q_page_cart_empty": "No items in your Quote cart.",
            "r4q_page_back_to_homepage": "Or {Back to Homepage}",
            "r4q_page_add_cart_to_quote": "ADD CART ITEMS TO QUOTE",
            "r4q_message_no_item_in_cart": "No items in your cart. Please select products or add products to cart.",
            "r4q_message_products_in_cart": "Products in your cart are not eligible for Quote. Please select other products.",
            "r4q_page_product": "Product",
            "r4q_page_price": "Price",
            "r4q_page_quantity": "Quantity",
            "r4q_form_title": "Contact Information",
            "r4q_form_subtitle": "In order to reach out to you we would like to know a bit more about you",
            "r4q_page_name": "Name",
            "r4q_page_email": "Email",
            "r4q_page_message": "Message",
            "r4q_page_address_country": "Country",
            "r4q_page_address_first_name": "First name",
            "r4q_page_address_last_name": "Last name",
            "r4q_page_address_company": "Company",
            "r4q_page_address_address1": "Address",
            "r4q_page_address_address2": "Apartment, suit, etc.",
            "r4q_page_address_city": "City",
            "r4q_page_address_phone": "Phone",
            "r4q_page_submit_request": "SUBMIT REQUEST",
            "r4q_page_thank": "THANKS!",
            "r4q_page_thank_for_quote": "THANK YOU FOR YOUR QUOTE!",
            "r4q_page_enter_offer_price": "Enter offer price",
            "r4q_page_confirm_quote": "Request Confirmation",
            "r4q_page_offer_price": "Offer price",
            "r4q_quote_table_title": "Product Review",
            "r4q_quote_table_subtitle": "The following products will be added to your quote request",
            "r4q_quote_table_id": "ID",
            "r4q_quote_table_created_at": "CREATE AT",
            "r4q_quote_table_quantity_of_items": "ITEM",
            "r4q_quote_table_subtotal": "SUBTOTAL",
            "r4q_quote_table_status": "STATUS",
            "r4q_quote_table_status_converted": "CONVERTED",
            "r4q_quote_table_status_open": "OPEN",
            "r4q_quote_table_action": "ACTION",
            "r4q_quote_table_showing": "Showing",
            "r4q_quote_table_quote": "quote(s)",
            "r4q_quote_view_back_to_my_quotes": "Back to My Quotes",
            "r4q_quote_view_quote": "Quote #",
            "r4q_quote_view_quote_date": "Create at",
            "r4q_quote_view_quote_total": "Total",
            "r4q_quote_view_quote_subtotal": "Subtotal",
            "r4q_quote_view_quote_shipping": "Shipping Fee",
            "r4q_quote_view_quote_tax": "Tax",
            "r4q_quote_view_created_at": "Created at",
            "r4q_quote_view_additional_details": "Additional details",
            "r4q_quote_view_form_additional_information": "Additional Information",
            "r4q_quote_view_address": "Shipping & Billing Addresses",
            "r4q_quote_view_estimated_total": "Estimated Total",
            "r4q_quote_view_shipping_address": "Shipping Addresses",
            "r4q_quote_view_billing_address": "Billing Addresses",
            "r4q_quote_view_items": "Items",
            "r4q_quote_view_items_detail": "items",
            "r4q_quote_view_image": "IMAGE",
            "r4q_quote_view_product": "PRODUCT",
            "r4q_quote_view_quantity": "QUANTITY",
            "r4q_quote_view_request_form": "Request Form",
            "r4q_page_quoted_price": "QUOTED PRICE",
            "r4q_page_amount": "AMOUNT",
            "r4q_approx_amount": "Approx.",
            "r4q_error_field_required": "This field is required",
            "r4q_error_invalid_email": "Invalid email",
            "r4q_message_contact_msg": "Please contact the store owner: Your account is not allowed to request a quote.",
            "add_to_quote": "Add to quote",
            "the_product": "The product",
            "added_to_quote": "is added to quote",
            "products_in_quote": "Current products in quote",
            "quote_table_image": "Image",
            "quote_table_product": "Product",
            "quote_table_quantity": "Quantity",
            "continue_shopping": "CONTINUE SHOPPING",
            "view_quote": "VIEW REQUEST",
            "r4q_message_items_not_allowed_to_quote": "The product(s) above is/are not eligible for Request a quote. They will be removed if you click the Add to quote button.",
            "r4q_page_process_to_quote_page": "Proceed to Add to quote page",
            "r4q_message_all_item_invalid": "These items are not eligible for checkout. Please add them to quote.",
            "r4q_page_add_other_to_quote": "Add others to quote",
            "r4q_page_cancel_btn": "Cancel",
            "r4q_page_view_information": "Additional Information",
            "r4q_page_previous": "Previous",
            "r4q_page_next": "Next",
            "r4q_page_process_to_checkout_page": "Proceed to checkout page",
            "r4q_page_invalid_product_to_quote": "Invalid products to quote",
            "r4q_page_product_not_allowed": "These following products are not allowed to quote:",
            "r4q_message_items_invalid_checkout": "Some items are not eligible for checkout. They will be remove if you click the Checkout button. Please add these items to quote.",
            "r4q_message_quote_note_title": "REQUEST FOR QUOTE NOTE",
            "r4q_message_quote_available": "Quote Available",
            "r4q_no_data_provided": "No {{label}} provided",
            "ro": {
                "re_order_text": "RE ORDER",
                "re_order_button": "Reorder",
                "review_order": "View Order",
                "submit_option": "Save",
                "order_list": "Previous Order List",
                "contact_msg_ro": "Please contact the store owner: Your account is not allowed for reorder.",
                "title_options": "If you have products in your cart:",
                "text_option_delete_and_update_cart": "Remove those products and add reordered ones to cart.",
                "text_option_update_cart": "Keep those products and add reordered products to cart.",
                "remove_button": "Remove",
                "selected_item_button": "selected item(s)",
                "id_header": "ID",
                "order_date_header": "ORDER DATE",
                "total_quantity_header": "TOTAL QUANTITY",
                "within_day_header": "",
                "all_orders_header": "All orders",
                "within_7_days_header": "Within 7 days",
                "within_15_days_header": "Within 15 days",
                "within_1_month_header": "Within 1 month",
                "within_2_months_header": "Within 2 months",
                "within_3_months_header": "Within 3 months",
                "within_6_months_header": "Within 6 months",
                "within_1_year_header": "Within 1 year",
                "number_per_page_header": "{{number per page}} per page",
                "sort_by": "Sort by",
                "date": "Date",
                "quantity": "Quantity",
                "subtotal": "Subtotal",
                "newest_to_oldest": "Newest to oldest",
                "oldest_to_newest": "Oldest to newest",
                "highest_to_lowest": "Highest to lowest",
                "lowest_to_highest": "Lowest to highest",
                "date_header": "Date",
                "no_of_product_header": "No of products",
                "previous_order_qty_header": "Previous Order qty",
                "image_header": "Image",
                "product_header": "Product Name",
                "sku_header": "SKU",
                "qty_default_header": "Qty default",
                "total_header": "Total",
                "edit_qty_header": "Edit Qty",
                "select_all_header": "Select All",
                "order_not_found_msg": "Order not found!",
                "text_option": "Options",
                "text_click_to_add_item": "Click \"Reorder\" to add all items from the previous order to your shopping cart. Click \"View order\" to review and update quantities for the previous order.",
                "text_note_display_product_price": "Noted: This order displays product price (excluded tax & shipping fee) from the past. The present price could be changed. Please add to cart or update quantity to see the new price!",
                "favorite_order": "Favorite orders",
                "ro_undo_button": "Undo",
                "order_mark_as_favorite_msg": "Marked as favorite",
                "order_remove_from_favorite_msg": "Removed from Favorite orders",
                "remove_from_favorite_button": "Remove from Favorite Orders",
                "ordered_at": "Order at",
                "total": "Total",
                "items_selected": "items selected",
                "ro_add_to_cart": "Add to cart",
                "ro_button_reset": "Reset",
                "ro_button_cancel": "Cancel",
                "ro_reorder_all": "Reorder All",
                "toast_view_cart": "View cart",
                "toast_message": "{{quantity}} item(s) added to cart"
            },
            "mo_my_orders": "Mis Ordenes / Mes commandes",
            "mo_search": "Buscar por #Orden o SKU",
            "mo_order_details": "Order details",
            "mo_items": "Item(s)",
            "mo_cart": "Cart",
            "mo_go_to_cart": "Go to cart",
            "mo_order_view_cart_button": "{{item}} item(s), {{quantity}} quantity(ies)",
            "mo_order": "Order",
            "mo_date": "Date",
            "mo_payment_status": "Payment status",
            "mo_fulfillment_status": "Fulfillment status",
            "mo_total": "Total",
            "mo_no_orders": "No orders found",
            "mo_no_items": "You have no items in your cart!",
            "mo_reorder": "Reorder",
            "mo_order_detail_header": "Order {{order_name}} detail",
            "mo_order_detail_back": "Back to my orders",
            "mo_order_detail_no_detail": "Fail getting order detail",
            "mo_order_partially_added": "Orders partially paid",
            "mo_order_partially_added_items_not_added": "Some items in this order have not been added to your cart",
            "mo_order_partially_added_not_available": "These items are no longer available",
            "mo_order_partially_added_out_of_stock": "These items are not currently in stock",
            "mo_order_partially_added_cancel": "Stay on this page",
            "mo_order_partially_added_add_to_reorder": "Add to Reorder Cart",
            "mo_order_detail_order_information": "Order information",
            "mo_order_detail_order_date": "Order date",
            "mo_order_detail_payment_status": "Payment status",
            "mo_order_detail_fulfillment_status": "Fulfillment status",
            "mo_order_detail_product": "Product",
            "mo_order_detail_price": "Price",
            "mo_order_detail_quantity": "Quantity",
            "mo_order_detail_product_total": "Total",
            "mo_order_detail_billing_address": "Billing address",
            "mo_order_detail_shipping_address": "Shipping address",
            "mo_order_detail_payment": "Payment",
            "mo_order_detail_subtotal": "Subtotal",
            "mo_order_detail_shipping": "Shipping",
            "mo_order_detail_total": "Total",
            "mo_order_detail_export_order": "Export order",
            "mo_order_detail_export_primary_action": "Export",
            "mo_order_detail_export_secondary_action": "Cancel",
            "mo_status_paid": "PAID",
            "mo_status_partially_paid": "PARTIALLY PAID",
            "mo_status_pending": "PENDING",
            "mo_status_fulfilled": "FULFILLED",
            "mo_status_partially_fulfilled": "PARTIALLY FULFILLED",
            "mo_status_unfulfilled": "UNFULFILLED",
            "mo_status_voided": "VOIDED",
            "ca_company_tax_number": "Company tax number",
            "ca_company_phone": "Company phone",
            "ca_company_account": "Cuenta Empresa / Compte d'entreprise",
            "ca_company": "Empresa / Entreprise",
            "ca_company_members": "Empleados / Employés",
            "ca_company_roles": "Roles / Rôles",
            "ca_company_orders": "Ordenes / Commandes",
            "ca_my_orders": "Mis Ordenes / Mes commandes",
            "ca_button_edit": "Editar",
            "ca_button_save": "Salvar",
            "ca_button_cancel": "Cancelar",
            "ca_button_invite": "Invitar a un nuevo miembro ",
            "ca_button_send_invite": "Enviar Invitación ",
            "ca_button_see_all_invites": "Ver todas las invitaciones enviadas",
            "ca_button_add_new_role": "Agregar un nuevo rol",
            "ca_button_create_order": "Crear órdenes con los items del carrito",
            "ca_button_request_create_company": "Crear Compañía ",
            "ca_button_send_request": "Enviar ",
            "ca_button_resend_request": "Re-enviar",
            "ca_button_remove": "Remover",
            "ca_button_close": "Cerrar",
            "ca_button_go_to_company": "Ir a la Empresa",
            "ca_button_delete": "Borrar",
            "ca_button_go_to_company_members": "Ir a los Miembros de la empresa",
            "ca_button_next": "Siguiente",
            "ca_button_prev": "Previo",
            "ca_button_confirm": "Confirmar",
            "ca_button_confirm_payment": "Confirmar Pago",
            "ca_apply_to_cart": "Apply Order To Cart",
            "ca_mark_as_paid": "Marcar como Pagado",
            "ca_button_share_cart": "Compartir Carrito",
            "ca_name_can_not_be_empty": "Name can not be empty",
            "ca_invalid_email": "Invalid Email",
            "ca_invalid_email_format": "Invalid email format",
            "ca_role_name_not_empty": "Role name can not be empty",
            "ca_first_name_not_empty": "First name can not be empty",
            "ca_last_name_not_empty": "Last name can not be empty",
            "ca_request_review": "Your request is being under review, please wait for approval",
            "ca_request_sent": "Request sent",
            "ca_request_rejected": "Your request was rejected, resend request or contact store owner for more information",
            "ca_company_disabled": "Your company was disabled, contact store owner for more information",
            "ca_sure_to_remove_member": "Are you sure to remove this member out of the company? This can't be undone",
            "ca_change_role_members": "There are several members having this role. To delete this role, you have to change members' roles or remove members first",
            "ca_sure_delete_role": "Are you sure to delete this role? This can't be undone",
            "ca_order_deleted": "Order deleted",
            "ca_company_role_deleted": "Company role deleted",
            "ca_company_role_added": "Company role added",
            "ca_items_added_to_cart": "Items added to cart, go to Cart page to checkout!",
            "ca_order_status_changed": "Order status changed to Paid!",
            "ca_company_role_updated": "Company role updated",
            "ca_company_information_saved": "Company information saved",
            "ca_invites_sent": "Invites sent to <<member's email>> successfully!",
            "ca_access_denied": "Access denied",
            "ca_permission_access": "You do not have permission to access this page",
            "ca_not_in_company": "You are not in any company",
            "ca_you_can": "You can",
            "ca_create_company": "Create a company",
            "ca_accept_below": "or accept below joining invites",
            "ca_first_time_use": "This is first time you use Company Accounts. Please confirm some information",
            "ca_request_approved": "Request approved, you are a member of the company now!",
            "ca_member_infor_saved": "Member information saved!",
            "ca_member_removed": "Member removed",
            "ca_edit_user": "Edit user",
            "ca_manager_protect": "Manager Protect",
            "ca_view_order_details": "Ver el detalle de la Orden",
            "ca_delete_user": "Delete user",
            "ca_invalid_form": "Invalid Form",
            "ca_your_information_confirmed": "Your information confirmed",
            "ca_invite_removed": "Invite removed",
            "ca_max_length_characters": "Maximum length is 100 characters",
            "ca_request_create_company": "Request to create company",
            "ca_company_information": "Company Information",
            "ca_company_name": "Company Name",
            "ca_company_email": "Company Email",
            "ca_manager_email": "Manager Email",
            "ca_manager": "Manager",
            "ca_address": "Address",
            "ca_company_address": "Company Address",
            "ca_your_information": "Your information",
            "ca_edit_company_profile": "Edit company profile",
            "ca_user_infor": "User Infor",
            "ca_first_name": "First name",
            "ca_last_name": "Last name",
            "ca_email_user": "Email",
            "ca_company_status": "Status",
            "ca_company_role": "Role",
            "ca_company_action": "Action",
            "ca_company_pending": "Pending",
            "ca_company_accept": "Accept",
            "ca_company_reject": "Reject",
            "ca_company_default": "Default",
            "ca_page_company_members": "Company Members",
            "ca_invalid_member": "Invite member",
            "ca_edit_member": "Edit member",
            "ca_remove_member": "Remove member",
            "ca_all_invites_sent": "All invites sent",
            "ca_name": "Name",
            "ca_role": "Role",
            "ca_manager_members": "Manager",
            "ca_default": "Default",
            "ca_email": "Email",
            "ca_member_email": "Member's email",
            "ca_action": "Action",
            "ca_created_at": "Created At",
            "ca_status": "Status",
            "ca_pending": "Pending",
            "ca_approved": "Accept",
            "ca_canceled": "Cancel",
            "ca_rejected": "Reject",
            "ca_undefined": "Undefined",
            "ca_member_address": "Address",
            "ca_roles": "Company Roles",
            "ca_create_new_role": "Create new role",
            "ca_edit_role": "Edit role",
            "ca_delete_role": "Delete role",
            "ca_cannot_edit": "Can't delete",
            "ca_role_name": "Role name",
            "ca_related_members": "Related members",
            "ca_permissions": "Permissions",
            "ca_action_roles": "Action",
            "ca_manage_company_orders": "Manage company orders",
            "ca_manage_roles": "Manage roles",
            "ca_manage_members": "Manage members",
            "ca_members_can_create_company_orders": "By default, all members can create company orders",
            "ca_orders": "Company Orders",
            "ca_my_orders_page": "My Orders",
            "ca_id": "ID",
            "ca_created_at_order": "Created At",
            "ca_order_name": "Name",
            "ca_order_by": "Ordered By",
            "ca_status_order": "Payment Status",
            "ca_paid_order": "Paid",
            "ca_not_paid_order": "Not paid",
            "ca_subtotal_order": "Subtotal",
            "ca_note_order": "Note",
            "ca_action_order": "Action",
            "ca_order_details": "Order details",
            "ca_items_order": "Items",
            "ca_estimated_subtotal": "Estimated subtotal",
            "ca_paid_by": "Paid by",
            "ca_confirm_payment_status": "Confirm Payment Status",
            "ca_confirm_payment_content": "Confirm Payment Status",
            "ca_product": "Product",
            "ca_title_share_company": "Title",
            "ca_total_share_company": "Total",
            "ca_subtotal_share_company": "Subtotal",
            "ca_clear_my_cart": "Clear my cart after sharing",
            "ca_your_cart": "Your cart",
            "ca_share_your_cart": "Share your cart to company",
            "ca_note_share_company": "Note",
            "ca_your_cart_empty_share_company": "Your Cart is Empty",
            "ca_appear_cart_after_sharing": "After sharing, your cart will appear at Company order as an order",
            "sr_please_contact_the_store_owner": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO USE SALE REP.",
            "sr_sales_rep": "Representante / Représentant",
            "sr_sales_rep_home": "Sales Rep Home",
            "sr_coupon": "Coupon",
            "sr_create_invoice": "Factura / Facture",
            "sr_manage_customers": "Clientes / Clients",
            "sr_manage_orders": "Ordenes / Ordres",
            "sr_btn_create_customer": "Crear Cliente",
            "sr_btn_preview_and_send_invoice": "Ver Factura",
            "sr_btn_preview_and_send_order": "Crear Orden",
            "sr_btn_add_to_order": "Agregar a la orden",
            "sr_btn_view_options": "Ver Opciones",
            "sr_btn_preview_order": "Vista previa ",
            "sr_btn_preview_order_items": "items",
            "sr_btn_preview_order_quantities": "cantidades",
            "sr_added_to_order": "Agregar a la orden",
            "sr_home_dashboard_text": "Tablero de Control",
            "sr_home_sales_current_month_text": "Performance del Mes",
            "sr_home_sales_by_filter_text": "Performance por Filtro",
            "sr_home_one_month_text": "1 Mes",
            "sr_home_three_months_text": "3 Meses",
            "sr_home_six_months_text": "6 Meses",
            "sr_home_nine_months_text": "9 Meses",
            "sr_home_twelve_months_text": "12 Meses",
            "sr_home_total_orders_text": "Total de Ordenes",
            "sr_home_commission_text": "Comision",
            "sr_home_sales_text": "Ventas",
            "sr_my_customers": "Mis Clientes",
            "sr_share_your_discount_coupon_code": "Share your Discount Coupon Code to customer!",
            "sr_your_coupon_code": "Your coupon code:",
            "sr_discount_amount": "Discount amount:",
            "sr_commission_rate": "Commission rate:",
            "sr_based_on_specific_product": "Based on specific product",
            "sr_mark_order_with_customers": "Mark order with customer",
            "sr_mark_with_customers": "Marcar como Cliente",
            "sr_customers_title_create": "Crear Cliente",
            "sr_customers_drop_down_created_at": "Created at",
            "sr_customers_all": "Todos",
            "sr_customers_last_seven_days": "Últimos 7 días",
            "sr_customers_last_thirty_days": "Últimos 30 días",
            "sr_customers_last_ninety_days": "Últimos 90 días",
            "sr_customers_last_twelve_months": "Últimos 12 meses",
            "sr_customers_my_customers": "Mis Clientes",
            "sr_customers_enter_customer_email": "Ingresar email del cliente",
            "sr_customers_no": "NO",
            "sr_customers_id": "ID del Cliente",
            "sr_customers_name": "NOMBRE",
            "sr_customers_email_table_text": "EMAIL",
            "sr_customers_total_commission": "TOTAL DE COMISIONES",
            "sr_customers_created_on": "CREADO EN",
            "sr_customers_actions": "ACCIONES",
            "sr_customer_overview": "Customer Overview",
            "sr_customers_first_name": "Nombre",
            "sr_customers_last_name": "Apellido",
            "sr_customers_email": "Email",
            "sr_customers_create_phone_number": "Número de Teléfono",
            "sr_customers_agreed_emails": "Customer agreed to receive marketing emails.",
            "sr_customers_agreed_receive_SMS": "Customer agreed to receive SMS marketing text messages.",
            "sr_customers_permission_notice": "You should ask your customers for permission before you subscribe them to your marketing emails or SMS.",
            "sr_customers_customer_address": "Dirección del Cliente",
            "sr_customers_country_region": "País / Región",
            "sr_customers_company": "Empresa",
            "sr_customers_address": "Dirección",
            "sr_customers_apartment_suite_etc": "Departamento, etc.",
            "sr_customers_city": "Ciudad",
            "sr_customers_postal_code": "Código Postal",
            "sr_customers_phone_number": "Tel",
            "sr_customers_customer_note": "Nota del Cliente",
            "sr_customers_note": "Nota",
            "sr_customers_checkout_notice": "*If a customer checkout with one of these emails, the order will be marked as your order (no need to login)",
            "sr_customers_customer": "Cliente",
            "sr_customers_email_lowercase": "Email",
            "sr_customers_created_at": "Creado en",
            "sr_customers_amount_spent": "Monto",
            "sr_customers_total_orders": "Total de la Orden",
            "sr_customers_status": "Status",
            "sr_customers_enabled_uppercase": "ENABLED",
            "sr_customers_disabled_uppercase": "DISABLED",
            "sr_customers_declined_uppercase": "DECLINED",
            "sr_customers_invited_uppercase": "INVITED",
            "sr_customers_tags": "Tags",
            "sr_customers_order": "ORDER",
            "sr_customers_date": "DATE",
            "sr_customers_payment": "PAYMENT",
            "sr_customers_fulfillment": "FULFILLMENT",
            "sr_customers_subtotal": "SUBTOTAL",
            "sr_customers_commission": "COMMISSION",
            "sr_customers_tax": "TAX",
            "sr_customers_total": "TOTAL",
            "sr_invoice_create_invoice_title": "Create Invoice",
            "sr_customer_info": "CUSTOMER INFO",
            "sr_invoice_all": "All",
            "sr_invoice_last_name_required": "Last name is required",
            "sr_invoice_city_required": "City is required",
            "sr_invoice_address_required": "Address is required",
            "sr_invoice_country_required": "Country is required",
            "sr_invoice_please_select_customer": "Please select customer to create invoice",
            "sr_invoice_customer": "List Customer",
            "sr_invoice_email": "Email",
            "sr_invoice_create_address": "Address",
            "sr_invoice_select_customer": "Select Customer",
            "sr_invoice_customer_email": "Customer Email",
            "sr_invoice_customer_address": "Customer address",
            "sr_invoice_shipping_address": "Shipping address",
            "sr_invoice_hide_shipping_address": "Hide shipping address",
            "sr_invoice_show_shipping_address": "Show shipping address",
            "sr_invoice_edit_shipping_address": "Edit shipping address",
            "sr_invoice_first_name": "First name",
            "sr_invoice_last_name": "Last name",
            "sr_invoice_address": "Address",
            "sr_invoice_company": "Company",
            "sr_invoice_apartment_suite_etc": "Apartment, suit, etc.",
            "sr_invoice_city": "City",
            "sr_invoice_country": "Country",
            "sr_invoice_postal_code": "Postal code",
            "sr_invoice_product_list": "PRODUCT LIST",
            "sr_invoice_add_note": "Add note",
            "sr_no_items_in_order": "No item in order",
            "sr_invoice_note_to_the_order": "Note to the order",
            "sr_invoice_select_products": "Seleccionar Productos",
            "sr_invoice_search_product_title_SKU": "Search product title, SKU",
            "sr_invoice_total_record": "Total Record",
            "sr_invoice_subtotal": "Subtotal",
            "sr_invoice_send_invoice": "Enviar Factura",
            "sr_invoice_cancel": "Cancelar",
            "sr_invoice_from": "From:",
            "sr_invoice_to": "To:",
            "sr_invoice_subject": "Subject:",
            "sr_invoice_success": "Success",
            "sr_invoice_send_invoice_successfully": "Send invoice successfully",
            "sr_invoice_send_invoice_failed": "Send invoice failed",
            "sr_invoice_send_order_successfully": "Send order successfully",
            "sr_invoice_in_stock": "In Stock",
            "sr_invoice_out_of_stock": "Out Of Stock",
            "sr_invoice_volume_pricing_available": "Volume pricing available",
            "sr_invoice_SKU": "SKU",
            "sr_invoice_commission": "Commission",
            "sr_invoice_shipping_address_updated": "Shipping address updated",
            "sr_invoice_qty": "qty",
            "sr_orders_my_orders": "My Orders",
            "sr_orders_all_orders": "All orders",
            "sr_orders_orders": "Orders",
            "sr_orders_draft_orders": "Draft Orders",
            "sr_orders_order": "ORDER",
            "sr_orders_order_date": "ORDER DATE",
            "sr_orders_customer": "CUSTOMER",
            "sr_orders_status": "STATUS",
            "sr_orders_tracking_number": "TRACKING NUMBER",
            "sr_draft_order_open": "OPEN",
            "sr_draft_order_invoice_sent": "INVOICE_SENT",
            "sr_orders_table_subtotal": "TOTAL",
            "sr_orders_commission": "COMMISSION",
            "sr_orders_action": "ACTION",
            "sr_orders_invoice": "INVOICE",
            "sr_orders_select_customer": "Select Customer",
            "sr_orders_order_info_customer": "Customer",
            "sr_orders_not_selected": "Not selected",
            "sr_orders_created_by": "Created by",
            "sr_orders_payment_status": "Payment status",
            "sr_orders_payment_paid": "PAID",
            "sr_orders_payment_pending": "PENDING",
            "sr_orders_fulfillment_status": "Fulfillment Status",
            "sr_orders_unfulfilled": "UNFULFILLED",
            "sr_orders_fulfilled": "FULFILLED",
            "sr_orders_created_at": "Create at",
            "sr_orders_commission_rate": "Commission rate",
            "sr_orders_tags": "Tags",
            "sr_orders_tracking_number_view": "Tracking number",
            "sr_orders_subtotal": "Subtotal",
            "sr_orders_discount": "Discount",
            "sr_orders_tax": "Tax",
            "sr_orders_shipping": "Shipping",
            "sr_orders_total": "Total",
            "sr_orders_no_preview_title": "There is no preview for order confirmation email. Once sent, you will not be able to make change to the email.",
            "sr_orders_no_preview_subtitle_1": "We suggest you  send a test email first.",
            "sr_orders_no_preview_subtitle_2": "Do you wish to continue?",
            "info_heading": "INFO",
            "info_personal_title": "Info Personal / Informations Personnelles",
            "info_personal_information_heading": "My information",
            "info_personal_b2b_information_heading": "B2B information",
            "info_personal_password_heading": "Change my password",
            "info_personal_address_heading": "Addresses",
            "info_personal_first_name_label": "First name",
            "info_personal_last_name_label": "Last name",
            "info_personal_email_label": "Email",
            "info_personal_email_consent_label": "Email me with news and offers",
            "info_personal_password_label": "New password",
            "info_personal_repeated_password_label": "Repeat password",
            "info_personal_company_label": "Company",
            "info_personal_address1_label": "Address",
            "info_personal_address2_label": "Apartment, suite, etc",
            "info_personal_city_label": "City",
            "info_personal_country_label": "Country",
            "info_personal_province_label": "Province",
            "info_personal_zip_label": "Postal/Zip code",
            "info_personal_phone_label": "Phone",
            "info_personal_default_address_label": "Set as default address",
            "info_personal_email_empty": "Email is required",
            "info_personal_email_invalid": "Email is invalid",
            "info_personal_password_empty": "Password is required",
            "info_personal_password_short": "Password must be at least 5 characters",
            "info_personal_repeated_password_empty": "Repeated password is required",
            "info_personal_repeated_password_unmatched": "Repeated password do not match",
            "info_personal_save_info": "Save details",
            "info_personal_save_password": "Save password",
            "info_personal_update_address": "Update address",
            "info_personal_add_address": "Add address",
            "info_personal_default_address": "Default address",
            "info_personal_delete_address": "Delete address",
            "info_personal_delete_address_content": "This can't be undone",
            "info_personal_phone_invalid": "Phone number is invalid",
            "info_personal_cancel": "Cancel",
            "info_personal_edit": "Edit",
            "info_personal_delete": "Delete",
            "info_orders_title": "My orders",
            "nt": {
                "netterm": "NET TERM/PURCHASE LATE",
                "cart_purchase": "Cart Purchase",
                "order_history": "Order History",
                "order_detail": "Order Detail",
                "purchase_late": "Purchase Late",
                "no_items": "No items in cart",
                "cp_checkout": "Checkout",
                "cp_shipping": "Continue to shipping",
                "cp_change": "Change",
                "nt_remove": "Remove",
                "nt_return_to_cart": "Return to cart",
                "nt_return_to_order_history": "Return to Order History",
                "nt_continue": "Continue",
                "pl_cart_subtotal": "Subtotal",
                "pl_cart_sku": "SKU",
                "pl_cart_price": "PRICE",
                "pl_cart_quantity": "QUANTITY",
                "pl_cart_shipping": "Shipping",
                "pl_cart_taxes": "Taxes",
                "pl_cart_total": "Total",
                "pl_cart_free": "Free",
                "pl_cart_taxes_included": "Including {{price}} in taxes",
                "login": "LOGIN",
                "email": "Email",
                "password": "Password",
                "signin": "Sign in",
                "return_store": "Return to store",
                "forgot": "Forgot your password?",
                "create": "Create an account",
                "contact_information": "CONTACT INFORMATION",
                "cp_email": "Email",
                "log_out": "Log out",
                "shipping_address": "SHIPPING ADDRESS",
                "billing_address": "BILLING ADDRESS",
                "use_ship_address_as_bill_address": "Use Shipping address as Billing address",
                "new_address": "Use a new address",
                "first_name": "First name (optional)",
                "last_name": "Last name",
                "company": "Company (optional)",
                "address": "Address",
                "apartment": "Apartment, suit, etc. (optional)",
                "city": "City",
                "postal_code": "Postal code",
                "personal_customs_code": "Personal Customs Code",
                "nt_cart_note": "Cart note",
                "required": "This field is required",
                "invalidEmail": "Please enter a valid email",
                "alert": "PLEASE CONTACT THE STORE OWNER. YOUR ACCOUNT IS NOT ALLOWED TO PURCHASE LATE.",
                "errorMessage": "Fill all required field and double check all errors",
                "due_on": "Your payment is due on",
                "additional_information": "ADDITIONAL INFORMATION",
                "nt_valid_eu_vat": "VALID EU VAT NUMBER",
                "nt_valid_abn": "VALID ABN NUMBER",
                "nt_valid_gst": "VALID INDIA GST NUMBER",
                "nt_valid_uk": "VALID UK VAT NUMBER",
                "nt_invalid_eu_vat": "EU VAT is not valid. Please re-enter",
                "nt_invalid_abn": "ABN is not valid. Please re-enter",
                "nt_invalid_gst": "GST number is not valid. Please re-enter",
                "nt_invalid_uk": "UK VAT Registration number is not valid. Please re-enter",
                "nt_invalid_postal_code": "Enter a valid ZIP/ postal code",
                "pl_shipping_contact": "Contact",
                "pl_shipping_shipto": "Ship to",
                "pl_shipping_method": "SHIPPING METHOD",
                "pl_shipping_error_heading": "No shipping rates found for this address.",
                "pl_shipping_error_message": "This order can't be shipped to the address you entered. Review your address to ensure that all fields have been entered correctly and try again.",
                "purchase_late_note": "PURCHASE LATE NOTE",
                "purchase_late_message": "Product(s) above is/are not eligible for Purchase Late. They will be removed if you click the Purchase Late button.",
                "purchase_late_link": "Proceed to purchase late page",
                "nt_out_of_stock_title": "Out of stock",
                "nt_out_of_stock_describe": "Some items are no longer available. Your cart has been updated.",
                "nt_out_of_stock_sold_out": "Sold out",
                "ot_name": "Name",
                "ot_email": "Email",
                "ot_shipping": "Shipping",
                "ot_rule": "Rule",
                "ot_date": "Order Date",
                "ot_netterms": "Net Terms",
                "ot_remaining_days": "Remaining Days",
                "ot_days": "day(s)",
                "ot_hours": "hour(s)",
                "ot_due_on_receipt": "Due on receipt",
                "ot_due_on_date": "Due on specific date",
                "pl_cart_product": "PRODUCT",
                "nt_edit": "Edit",
                "nt_cancel": "Cancel",
                "nt_save": "Save",
                "nt_stay": "Stay",
                "nt_search_input": "Enter order name",
                "nt_search_btn": "Search",
                "nt_sort_by": "Sort by",
                "nt_new_to_old": "Newest to oldest",
                "nt_old_to_new": "Oldest to newest",
                "nt_a_to_z": "Name A-Z",
                "nt_z_to_a": "Name Z-A",
                "nt_short_to_long": "Net terms Shortest to Longest",
                "nt_long_to_short": "Net terms Longest to Shortest",
                "nt_remain_days_asc": "Ascending Remaining days",
                "nt_remain_days_desc": "Descending Remaining days",
                "nt_save_to_calculate": "Save to calculate",
                "nt_empty_cart": "Your cart is empty",
                "nt_checkout_unsaved_changes": "Checkout with unsaved changes?",
                "nt_checkout_saving_current_edits": "If you click Checkout, you will proceed to checkout your previous cart without saving current edits.",
                "nt_continue_shipping": "Continue to shipping with unsaved changes?",
                "nt_shipping_saving_current_edits": "If you click Continue to shipping, you will proceed with your previous cart without saving current edits.",
                "restrict_value_greater": "Your cart's total value must be greater than or equal to {{value}}",
                "restrict_value_less": "Your cart's total value must be less than or equal to {{value}}",
                "restrict_quantity_greater": "The quantity of items in your cart must be greater than or equal to {{value}}",
                "restrict_quantity_less": "The quantity of items in your cart must be less than or equal to {{value}}",
                "order_detail_no_detail": "Fail getting order detail",
                "due_on_payment": "Due on payment"
            },
            "qo": {
                "quick_order_navigation_menu": "QUICK ORDER",
                "quick_order_list": "Product List",
                "quick_order_cart": "Preview Cart",
                "go_to_cart": "Go To Cart",
                "checkout_btn": "Checkout",
                "sync_with_cart": "SYNC WITH CART",
                "sync_with_cart_banner_info": "Click 'SYNC WITH CART' to keep your Preview cart and Cart perfectly aligned. Never lose track of your items -- sync now for a smoother shopping journey!",
                "add_to_cart": "Add to cart",
                "contact_msg": "Please contact the store owner: Your account is not allowed for quick order.",
                "failed_msg": "Failed to find product(s)",
                "total_record": "Total Record",
                "sku": "SKU",
                "barcode": "Barcode",
                "subtotal": "Subtotal",
                "search_product_title_sku": "Search Product title, SKU",
                "all": "All",
                "title_az": "Title A-Z",
                "title_za": "Title Z-A",
                "newest_created_date": "Newest Created Date",
                "oldest_created_date": "Oldest Created Date",
                "inventory_quantity_lowest_to_highest": "Inventory Quantity Lowest to Highest",
                "inventory_quantity_highest_to_lowest": "Inventory Quantity Highest to Lowest",
                "price_lowest_to_highest": "Price Lowest to Highest",
                "price_highest_to_lowest": "Price Highest to Lowest",
                "qo_loading_type": "Load more",
                "end_of_list": "You've reached the end of the list.",
                "add_all": "Add {{items}} items to cart",
                "remove_all": "Remove all items",
                "sort_collection": "Collection",
                "from": "From",
                "view_option": "View options",
                "in_stock": "In Stock",
                "out_of_stock": "Out Of Stock",
                "price_cut": "PRICE CUT",
                "save_discount": "SAVE",
                "popup_added_to_cart": "Added to Cart",
                "volume_pricing_available": "Volume pricing available",
                "no_line_items_cart": "You have no items in your cart!",
                "add_to_cart_error": "Some unexpected error happened. please try again",
                "cart_items": "items",
                "cart_quantities": "quantities",
                "synced_with_cart_toast": "Synced with Cart",
                "product_types": "PRODUCT TYPES",
                "collections": "COLLECTIONS"
            }
        },
        fr: {
            "b2b_customer_portal": "Portail client B2B",
            "error_message": "Le(s) produit(s) ci-dessus ne sont pas éligibles pour un devis. Ils seront supprimés si vous cliquez sur le bouton « Ajouter au devis ».",
            "go_to_cart": "Aller au panier",
            "checkout": "Passer à la caisse",
            "purchase_late": "Achat différé",
            "quick_order": "COMMANDE RAPIDE",
            "product_list": "Liste de produits",
            "netterm": "CONDITIONS NETTES/ACHAT DIFFÉRÉ",
            "cart_purchase": "Achat par panier",
            "order_history": "Historique des commandes",
            "order_detail": "Détails de la commande",
            "add_to_cart": "Ajouter au panier",
            "search_product_title_sku": "Rechercher par titre de produit, SKU",
            "added_msg": "article(s) ajouté(s) au panier",
            "contact_msg": "Veuillez contacter le propriétaire de la boutique : votre compte n'est pas autorisé pour les commandes rapides.",
            "failed_msg": "Impossible de trouver le(s) produit(s)",
            "available_qty": "Qté disponible",
            "qty": "qté",
            "product_title": "Titre du produit",
            "price": "Prix",
            "total_record": "Total des enregistrements",
            "sku": "SKU",
            "all": "Tous",
            "sort_by": "Trier par",
            "name_az": "Nom A-Z",
            "name_za": "Nom Z-A",
            "newest_created_date": "Date de création la plus récente",
            "oldest_created_date": "Date de création la plus ancienne",
            "newest_updated": "Date de mise à jour la plus récente",
            "oldest_updated": "Date de mise à jour la plus ancienne",
            "inventory_quantity_lowest_to_highest": "Quantité en stock croissante",
            "inventory_quantity_highest_to_lowest": "Quantité en stock décroissante",
            "popular": "Populaire",
            "price_lowest_to_highest": "Prix croissant",
            "price_highest_to_lowest": "Prix décroissant",
            "sku_az": "SKU A-Z",
            "sku_za": "SKU Z-A",
            "selected_item": "article(s) sélectionné(s)",
            "no_items": "Aucun article dans le panier",
            "login": "CONNEXION",
            "email": "E-mail",
            "password": "Mot de passe",
            "signin": "Se connecter",
            "logout": "Se déconnecter",
            "open_sidebar": "Ouvrir la barre latérale",
            "close_sidebar": "Fermer la barre latérale",
            "go_to_page": "Aller à la page",
            "return_store": "Retour à la boutique",
            "forgot": "Mot de passe oublié ?",
            "create": "Créer un compte",
            "contact_information": "COORDONNÉES",
            "log_out": "Se déconnecter",
            "shipping_address": "Adresse d'expédition",
            "new_address": "Utiliser une nouvelle adresse",
            "first_name": "Prénom (facultatif)",
            "last_name": "Nom",
            "company": "Entreprise (facultatif)",
            "address": "Adresse",
            "billing_address": "Adresse de facturation",
            "apartment": "Appartement, suite, etc. (facultatif)",
            "city": "Ville",
            "postal_code": "Code postal",
            "required": "Ce champ est obligatoire",
            "invalidEmail": "Veuillez entrer une adresse e-mail valide",
            "alert": "VEUILLEZ CONTACTER LE PROPRIÉTAIRE DE LA BOUTIQUE. VOTRE COMPTE N'EST PAS AUTORISÉ À EFFECTUER DES ACHATS DIFFÉRÉS.",
            "due_on": "Votre paiement est dû le",
            "additional_information": "INFORMATIONS COMPLÉMENTAIRES",
            "nt_valid_eu_vat": "NUMÉRO DE TVA UE VALIDE",
            "nt_valid_abn": "NUMÉRO ABN VALIDE",
            "nt_valid_gst": "NUMÉRO GST INDE VALIDE",
            "nt_valid_uk": "NUMÉRO DE TVA UK VALIDE",
            "nt_invalid_eu_vat": "La TVA UE n'est pas valide. Veuillez la ressaisir",
            "nt_invalid_abn": "L'ABN n'est pas valide. Veuillez le ressaisir",
            "nt_invalid_gst": "Le numéro GST n'est pas valide. Veuillez le ressaisir",
            "nt_invalid_uk": "Le numéro de TVA UK n'est pas valide. Veuillez le ressaisir",
            "nt_invalid_postal_code": "Entrez un code postal valide",
            "nt_uploading_video": "Le téléchargement de la vidéo prend 30 secondes, veuillez patienter.",
            "purchase_late_note": "NOTE D'ACHAT DIFFÉRÉ",
            "purchase_late_message": "Le(s) produit(s) ci-dessus ne sont pas éligibles pour l'achat différé. Ils seront supprimés si vous cliquez sur le bouton Achat différé.",
            "purchase_late_link": "Accéder à la page d'achat différé",
            "purchase_late_link_login": "Accéder à la page de connexion/inscription",
            "purchase_late_message_qualify": "Vous n'avez pas été qualifié pour utiliser ces conditions de paiement. Veuillez nous contacter pour plus de détails.",
            "purchase_late_message_login": "Veuillez vous connecter ou créer un compte pour acheter ces articles en différé",
            "nt_out_of_stock_title": "Rupture de stock",
            "nt_out_of_stock_describe": "Certains articles ne sont plus disponibles. Votre panier a été mis à jour.",
            "nt_remove": "Supprimer",
            "nt_return_to_cart": "Retour au panier",
            "nt_return_to_order_history": "Retour à l'historique des commandes",
            "nt_continue": "Continuer",
            "nt_out_of_stock_sold_out": "Épuisé",
            "nt_edit": "Modifier",
            "nt_cancel": "Annuler",
            "nt_save": "Enregistrer",
            "nt_stay": "Rester",
            "nt_save_to_calculate": "Enregistrer pour calculer",
            "nt_checkout_unsaved_changes": "Passer à la caisse avec des modifications non enregistrées ?",
            "nt_checkout_saving_current_edits": "Si vous cliquez sur Passer à la caisse, vous procéderez avec votre panier précédent sans enregistrer les modifications actuelles.",
            "nt_continue_shipping": "Continuer vers l'expédition avec des modifications non enregistrées ?",
            "nt_shipping_saving_current_edits": "Si vous cliquez sur Continuer vers l'expédition, vous procéderez avec votre panier précédent sans enregistrer les modifications actuelles.",
            "nt_empty_cart": "Votre panier est vide",
            "use_ship_address_as_bill_address": "Utiliser l'adresse d'expédition comme adresse de facturation",
            "ot_name": "Nom",
            "ot_email": "E-mail",
            "ot_shipping": "Expédition",
            "ot_rule": "Règle",
            "ot_date": "Date de commande",
            "ot_netterms": "Conditions nettes",
            "ot_remaining_days": "Jours restants",
            "ot_days": "jour(s)",
            "dashboard": "Tableau de bord",
            "cp_checkout": "Passer à la caisse",
            "cp_shipping": "Continuer vers l'expédition",
            "cp_tax": "Continuer vers les taxes",
            "cp_email": "E-mail",
            "cp_change": "Modifier",
            "pl_cart_product": "PRODUIT",
            "restrict_value_greater": "La valeur totale de votre panier doit être supérieure ou égale à {{value}}",
            "restrict_value_less": "La valeur totale de votre panier doit être inférieure ou égale à {{value}}",
            "restrict_quantity_greater": "La quantité d'articles dans votre panier doit être supérieure ou égale à {{value}}",
            "restrict_quantity_less": "La quantité d'articles dans votre panier doit être inférieure ou égale à {{value}}",
            "order_detail_no_detail": "Échec de la récupération des détails de la commande",
            "pl_cart_subtotal": "Sous-total",
            "pl_cart_sku": "SKU",
            "pl_cart_price": "PRIX",
            "pl_cart_quantity": "QUANTITÉ",
            "pl_cart_shipping": "Expédition",
            "pl_cart_taxes": "Taxes",
            "pl_cart_total": "Total",
            "pl_cart_free": "Gratuit",
            "pl_cart_taxes_included": "Inclut {{price}} de taxes",
            "pl_shipping_contact": "Contact",
            "pl_shipping_shipto": "Expédier à",
            "pl_billing": "Facturation",
            "pl_shipping_method": "MODE D'EXPÉDITION",
            "pl_shipping_error_heading": "Aucun tarif d'expédition trouvé pour cette adresse.",
            "pl_shipping_error_message": "Cette commande ne peut pas être expédiée à l'adresse indiquée. Vérifiez votre adresse pour vous assurer que tous les champs ont été saisis correctement et réessayez.",
            "vo_inStock": "En stock",
            "vo_outOfStock": "Rupture de stock",
            "vo_unlimited": "Illimité",
            "vo_addToCart": "Ajouter au panier",
            "vo_atLeast1Item": "Au moins 1 article doit être ajouté au panier",
            "vo_buyItNow": "Acheter maintenant",
            "r4q_tab_request_for_quote": "DEMANDER UN DEVIS",
            "r4q_tab_quote_cart": "Panier de devis",
            "r4q_tab_my_quote": "Mes devis",
            "r4q_page_request_for_quote": "DEMANDER UN DEVIS",
            "r4q_page_cart_empty": "Aucun article dans votre panier de devis.",
            "r4q_page_back_to_homepage": "Ou {Back to Homepage}",
            "r4q_page_add_cart_to_quote": "AJOUTER LES ARTICLES DU PANIER AU DEVIS",
            "r4q_message_no_item_in_cart": "Aucun article dans votre panier. Veuillez sélectionner des produits ou les ajouter au panier.",
            "r4q_message_products_in_cart": "Les produits de votre panier ne sont pas éligibles pour un devis. Veuillez sélectionner d'autres produits.",
            "r4q_page_product": "Produit",
            "r4q_page_price": "Prix",
            "r4q_page_quantity": "Quantité",
            "r4q_form_title": "Coordonnées",
            "r4q_form_subtitle": "Afin de vous contacter, nous aimerions en savoir un peu plus sur vous",
            "r4q_page_name": "Nom",
            "r4q_page_email": "E-mail",
            "r4q_page_message": "Message",
            "r4q_page_address_country": "Pays",
            "r4q_page_address_first_name": "Prénom",
            "r4q_page_address_last_name": "Nom",
            "r4q_page_address_company": "Entreprise",
            "r4q_page_address_address1": "Adresse",
            "r4q_page_address_address2": "Appartement, suite, etc.",
            "r4q_page_address_city": "Ville",
            "r4q_page_address_phone": "Téléphone",
            "r4q_page_submit_request": "ENVOYER LA DEMANDE",
            "r4q_page_thank": "MERCI !",
            "r4q_page_thank_for_quote": "MERCI POUR VOTRE DEVIS !",
            "r4q_page_enter_offer_price": "Entrez le prix de l'offre",
            "r4q_page_confirm_quote": "Confirmation de la demande",
            "r4q_page_offer_price": "Prix de l'offre",
            "r4q_quote_table_title": "Révision du produit",
            "r4q_quote_table_subtitle": "Les produits suivants seront ajoutés à votre demande de devis",
            "r4q_quote_table_id": "ID",
            "r4q_quote_table_created_at": "CRÉÉ LE",
            "r4q_quote_table_quantity_of_items": "ARTICLE",
            "r4q_quote_table_subtotal": "SOUS-TOTAL",
            "r4q_quote_table_status": "STATUT",
            "r4q_quote_table_status_converted": "CONVERTI",
            "r4q_quote_table_status_open": "OUVERT",
            "r4q_quote_table_action": "ACTION",
            "r4q_quote_table_showing": "Affichage de",
            "r4q_quote_table_quote": "devis",
            "r4q_quote_view_back_to_my_quotes": "Retour à mes devis",
            "r4q_quote_view_quote": "Devis n°",
            "r4q_quote_view_quote_date": "Créé le",
            "r4q_quote_view_quote_total": "Total",
            "r4q_quote_view_quote_subtotal": "Sous-total",
            "r4q_quote_view_quote_shipping": "Frais d'expédition",
            "r4q_quote_view_quote_tax": "Taxe",
            "r4q_quote_view_created_at": "Créé le",
            "r4q_quote_view_additional_details": "Détails supplémentaires",
            "r4q_quote_view_form_additional_information": "Informations complémentaires",
            "r4q_quote_view_address": "Adresses d'expédition et de facturation",
            "r4q_quote_view_estimated_total": "Total estimé",
            "r4q_quote_view_shipping_address": "Adresses d'expédition",
            "r4q_quote_view_billing_address": "Adresses de facturation",
            "r4q_quote_view_items": "Articles",
            "r4q_quote_view_items_detail": "articles",
            "r4q_quote_view_image": "IMAGE",
            "r4q_quote_view_product": "PRODUIT",
            "r4q_quote_view_quantity": "QUANTITÉ",
            "r4q_quote_view_request_form": "Formulaire de demande",
            "r4q_page_quoted_price": "PRIX DEVISÉ",
            "r4q_page_amount": "MONTANT",
            "r4q_approx_amount": "Approx.",
            "r4q_error_field_required": "Ce champ est obligatoire",
            "r4q_error_invalid_email": "E-mail non valide",
            "r4q_message_contact_msg": "Veuillez contacter le propriétaire de la boutique : votre compte n'est pas autorisé à demander un devis.",
            "add_to_quote": "Ajouter au devis",
            "the_product": "Le produit",
            "added_to_quote": "est ajouté au devis",
            "products_in_quote": "Produits actuellement dans le devis",
            "quote_table_image": "Image",
            "quote_table_product": "Produit",
            "quote_table_quantity": "Quantité",
            "continue_shopping": "CONTINUER MES ACHATS",
            "view_quote": "VOIR LA DEMANDE",
            "r4q_message_items_not_allowed_to_quote": "Le(s) produit(s) ci-dessus ne sont pas éligibles pour une demande de devis. Ils seront supprimés si vous cliquez sur le bouton Ajouter au devis.",
            "r4q_page_process_to_quote_page": "Accéder à la page Ajouter au devis",
            "r4q_message_all_item_invalid": "Ces articles ne sont pas éligibles au passage à la caisse. Veuillez les ajouter au devis.",
            "r4q_page_add_other_to_quote": "Ajouter d'autres articles au devis",
            "r4q_page_cancel_btn": "Annuler",
            "r4q_page_view_information": "Informations complémentaires",
            "r4q_page_previous": "Précédent",
            "r4q_page_next": "Suivant",
            "r4q_page_process_to_checkout_page": "Accéder à la page de paiement",
            "r4q_page_invalid_product_to_quote": "Produits non valides pour le devis",
            "r4q_page_product_not_allowed": "Les produits suivants ne sont pas autorisés pour le devis :",
            "r4q_message_items_invalid_checkout": "Certains articles ne sont pas éligibles au passage à la caisse. Ils seront supprimés si vous cliquez sur le bouton Passer à la caisse. Veuillez ajouter ces articles au devis.",
            "r4q_message_quote_note_title": "NOTE DE DEMANDE DE DEVIS",
            "r4q_message_quote_available": "Devis disponible",
            "r4q_no_data_provided": "Aucun(e) {{label}} fourni(e)",
            "ro": {
                "re_order_text": "RECOMMANDER",
                "re_order_button": "Renouveler la commande",
                "review_order": "Voir la commande",
                "submit_option": "Enregistrer",
                "order_list": "Liste des commandes précédentes",
                "contact_msg_ro": "Veuillez contacter le propriétaire de la boutique : votre compte n'est pas autorisé pour le renouvellement de commande.",
                "title_options": "Si vous avez des produits dans votre panier :",
                "text_option_delete_and_update_cart": "Supprimer ces produits et ajouter les articles recommandés au panier.",
                "text_option_update_cart": "Conserver ces produits et ajouter les articles recommandés au panier.",
                "remove_button": "Supprimer",
                "selected_item_button": "article(s) sélectionné(s)",
                "id_header": "ID",
                "order_date_header": "DATE DE COMMANDE",
                "total_quantity_header": "QUANTITÉ TOTALE",
                "within_day_header": "",
                "all_orders_header": "Toutes les commandes",
                "within_7_days_header": "Moins de 7 jours",
                "within_15_days_header": "Moins de 15 jours",
                "within_1_month_header": "Moins d'un mois",
                "within_2_months_header": "Moins de 2 mois",
                "within_3_months_header": "Moins de 3 mois",
                "within_6_months_header": "Moins de 6 mois",
                "within_1_year_header": "Moins d'un an",
                "number_per_page_header": "{{number per page}} par page",
                "sort_by": "Trier par",
                "date": "Date",
                "quantity": "Quantité",
                "subtotal": "Sous-total",
                "newest_to_oldest": "Du plus récent au plus ancien",
                "oldest_to_newest": "Du plus ancien au plus récent",
                "highest_to_lowest": "Du plus haut au plus bas",
                "lowest_to_highest": "Du plus bas au plus haut",
                "date_header": "Date",
                "no_of_product_header": "Nombre de produits",
                "previous_order_qty_header": "Qté commande précédente",
                "image_header": "Image",
                "product_header": "Nom du produit",
                "sku_header": "SKU",
                "qty_default_header": "Qté par défaut",
                "total_header": "Total",
                "edit_qty_header": "Modifier qté",
                "select_all_header": "Tout sélectionner",
                "order_not_found_msg": "Commande non trouvée !",
                "text_option": "Options",
                "text_click_to_add_item": "Cliquez sur « Renouveler la commande » pour ajouter tous les articles de la commande précédente à votre panier. Cliquez sur « Voir la commande » pour réviser et mettre à jour les quantités.",
                "text_note_display_product_price": "Note : Cette commande affiche le prix des produits (hors taxes et frais d'expédition) du passé. Le prix actuel peut avoir changé. Veuillez ajouter au panier ou mettre à jour la quantité pour voir le nouveau prix !",
                "favorite_order": "Commandes favorites",
                "ro_undo_button": "Annuler",
                "order_mark_as_favorite_msg": "Marqué comme favori",
                "order_remove_from_favorite_msg": "Retiré des commandes favorites",
                "remove_from_favorite_button": "Retirer des commandes favorites",
                "ordered_at": "Commandé le",
                "total": "Total",
                "items_selected": "articles sélectionnés",
                "ro_add_to_cart": "Ajouter au panier",
                "ro_button_reset": "Réinitialiser",
                "ro_button_cancel": "Annuler",
                "ro_reorder_all": "Tout recommander",
                "toast_view_cart": "Voir le panier",
                "toast_message": "{{quantity}} article(s) ajouté(s) au panier"
            },
            "mo_my_orders": "Mes commandes",
            "mo_search": "Rechercher par n° de commande ou SKU",
            "mo_order_details": "Détails de la commande",
            "mo_items": "Article(s)",
            "mo_cart": "Panier",
            "mo_go_to_cart": "Aller au panier",
            "mo_order_view_cart_button": "{{item}} article(s), {{quantity}} quantité(s)",
            "mo_order": "Commande",
            "mo_date": "Date",
            "mo_payment_status": "Statut du paiement",
            "mo_fulfillment_status": "Statut du traitement",
            "mo_total": "Total",
            "mo_no_orders": "Aucune commande trouvée",
            "mo_no_items": "Votre panier est vide !",
            "mo_reorder": "Renouveler la commande",
            "mo_order_detail_header": "Détails de la commande {{order_name}}",
            "mo_order_detail_back": "Retour à mes commandes",
            "mo_order_detail_no_detail": "Échec de la récupération des détails de la commande",
            "mo_order_partially_added": "Commandes partiellement payées",
            "mo_order_partially_added_items_not_added": "Certains articles de cette commande n'ont pas été ajoutés à votre panier",
            "mo_order_partially_added_not_available": "Ces articles ne sont plus disponibles",
            "mo_order_partially_added_out_of_stock": "Ces articles ne sont pas en stock actuellement",
            "mo_order_partially_added_cancel": "Rester sur cette page",
            "mo_order_partially_added_add_to_reorder": "Ajouter au panier de renouvellement",
            "mo_order_detail_order_information": "Informations sur la commande",
            "mo_order_detail_order_date": "Date de commande",
            "mo_order_detail_payment_status": "Statut du paiement",
            "mo_order_detail_fulfillment_status": "Statut du traitement",
            "mo_order_detail_product": "Produit",
            "mo_order_detail_price": "Prix",
            "mo_order_detail_quantity": "Quantité",
            "mo_order_detail_product_total": "Total",
            "mo_order_detail_billing_address": "Adresse de facturation",
            "mo_order_detail_shipping_address": "Adresse d'expédition",
            "mo_order_detail_payment": "Paiement",
            "mo_order_detail_subtotal": "Sous-total",
            "mo_order_detail_shipping": "Expédition",
            "mo_order_detail_total": "Total",
            "mo_order_detail_export_order": "Exporter la commande",
            "mo_order_detail_export_primary_action": "Exporter",
            "mo_order_detail_export_secondary_action": "Annuler",
            "mo_status_paid": "PAYÉ",
            "mo_status_partially_paid": "PARTIELLEMENT PAYÉ",
            "mo_status_pending": "EN ATTENTE",
            "mo_status_fulfilled": "TRAITÉ",
            "mo_status_partially_fulfilled": "PARTIELLEMENT TRAITÉ",
            "mo_status_unfulfilled": "NON TRAITÉ",
            "mo_status_voided": "ANNULÉ",
            "ca_company_tax_number": "Numéro de taxe de l'entreprise",
            "ca_company_phone": "Téléphone de l'entreprise",
            "ca_company_account": "COMPTES D'ENTREPRISE",
            "ca_company": "Entreprise",
            "ca_company_members": "Membres de l'entreprise",
            "ca_company_roles": "Rôles de l'entreprise",
            "ca_company_orders": "Commandes de l'entreprise",
            "ca_my_orders": "Mes commandes",
            "ca_button_edit": "Modifier",
            "ca_button_save": "Enregistrer",
            "ca_button_cancel": "Annuler",
            "ca_button_invite": "Inviter un nouveau membre",
            "ca_button_send_invite": "Envoyer l'invitation",
            "ca_button_see_all_invites": "Voir toutes les invitations envoyées",
            "ca_button_add_new_role": "Ajouter un nouveau rôle",
            "ca_button_create_order": "Créer une commande avec les articles du panier",
            "ca_button_request_create_company": "Demander la création d'une entreprise",
            "ca_button_send_request": "Envoyer la demande",
            "ca_button_resend_request": "Renvoyer la demande",
            "ca_button_remove": "Supprimer",
            "ca_button_close": "Fermer",
            "ca_button_go_to_company": "Aller à l'entreprise",
            "ca_button_delete": "Supprimer",
            "ca_button_go_to_company_members": "Aller aux membres de l'entreprise",
            "ca_button_next": "Suivant",
            "ca_button_prev": "Précédent",
            "ca_button_confirm": "Confirmer",
            "ca_button_confirm_payment": "Confirmer le paiement",
            "ca_apply_to_cart": "Appliquer la commande au panier",
            "ca_mark_as_paid": "Marquer comme payé",
            "ca_button_share_cart": "Partager le panier",
            "ca_name_can_not_be_empty": "Le nom ne peut pas être vide",
            "ca_invalid_email": "E-mail non valide",
            "ca_invalid_email_format": "Format d'e-mail non valide",
            "ca_role_name_not_empty": "Le nom du rôle ne peut pas être vide",
            "ca_first_name_not_empty": "Le prénom ne peut pas être vide",
            "ca_last_name_not_empty": "Le nom ne peut pas être vide",
            "ca_request_review": "Votre demande est en cours d'examen, veuillez patienter pour l'approbation",
            "ca_request_sent": "Demande envoyée",
            "ca_request_rejected": "Votre demande a été rejetée, renvoyez la demande ou contactez le propriétaire de la boutique pour plus d'informations",
            "ca_company_disabled": "Votre entreprise a été désactivée, contactez le propriétaire de la boutique pour plus d'informations",
            "ca_sure_to_remove_member": "Êtes-vous sûr de vouloir retirer ce membre de l'entreprise ? Cette action est irréversible",
            "ca_change_role_members": "Plusieurs membres possèdent ce rôle. Pour supprimer ce rôle, vous devez d'abord changer les rôles des membres ou les retirer",
            "ca_sure_delete_role": "Êtes-vous sûr de vouloir supprimer ce rôle ? Cette action est irréversible",
            "ca_order_deleted": "Commande supprimée",
            "ca_company_role_deleted": "Rôle d'entreprise supprimé",
            "ca_company_role_added": "Rôle d'entreprise ajouté",
            "ca_items_added_to_cart": "Articles ajoutés au panier, allez à la page du panier pour passer la commande !",
            "ca_order_status_changed": "Le statut de la commande est passé à Payé !",
            "ca_company_role_updated": "Rôle d'entreprise mis à jour",
            "ca_company_information_saved": "Informations sur l'entreprise enregistrées",
            "ca_invites_sent": "Invitations envoyées à <<member's email>> avec succès !",
            "ca_access_denied": "Accès refusé",
            "ca_permission_access": "Vous n'avez pas l'autorisation d'accéder à cette page",
            "ca_not_in_company": "Vous ne faites partie d'aucune entreprise",
            "ca_you_can": "Vous pouvez",
            "ca_create_company": "Créer une entreprise",
            "ca_accept_below": "ou accepter les invitations ci-dessous",
            "ca_first_time_use": "C'est la première fois que vous utilisez les comptes d'entreprise. Veuillez confirmer certaines informations",
            "ca_request_approved": "Demande approuvée, vous êtes maintenant membre de l'entreprise !",
            "ca_member_infor_saved": "Informations sur le membre enregistrées !",
            "ca_member_removed": "Membre retiré",
            "ca_edit_user": "Modifier l'utilisateur",
            "ca_manager_protect": "Protection du gestionnaire",
            "ca_view_order_details": "Voir les détails de la commande",
            "ca_delete_user": "Supprimer l'utilisateur",
            "ca_invalid_form": "Formulaire non valide",
            "ca_your_information_confirmed": "Vos informations ont été confirmées",
            "ca_invite_removed": "Invitation retirée",
            "ca_max_length_characters": "La longueur maximale est de 100 caractères",
            "ca_request_create_company": "Demander la création d'une entreprise",
            "ca_company_information": "Informations sur l'entreprise",
            "ca_company_name": "Nom de l'entreprise",
            "ca_company_email": "E-mail de l'entreprise",
            "ca_manager_email": "E-mail du gestionnaire",
            "ca_manager": "Gestionnaire",
            "ca_address": "Adresse",
            "ca_company_address": "Adresse de l'entreprise",
            "ca_your_information": "Vos informations",
            "ca_edit_company_profile": "Modifier le profil de l'entreprise",
            "ca_user_infor": "Infos utilisateur",
            "ca_first_name": "Prénom",
            "ca_last_name": "Nom",
            "ca_email_user": "E-mail",
            "ca_company_status": "Statut",
            "ca_company_role": "Rôle",
            "ca_company_action": "Action",
            "ca_company_pending": "En attente",
            "ca_company_accept": "Accepter",
            "ca_company_reject": "Rejeter",
            "ca_company_default": "Par défaut",
            "ca_page_company_members": "Membres de l'entreprise",
            "ca_invalid_member": "Inviter un membre",
            "ca_edit_member": "Modifier le membre",
            "ca_remove_member": "Retirer le membre",
            "ca_all_invites_sent": "Toutes les invitations envoyées",
            "ca_name": "Nom",
            "ca_role": "Rôle",
            "ca_manager_members": "Gestionnaire",
            "ca_default": "Par défaut",
            "ca_email": "E-mail",
            "ca_member_email": "E-mail du membre",
            "ca_action": "Action",
            "ca_created_at": "Créé le",
            "ca_status": "Statut",
            "ca_pending": "En attente",
            "ca_approved": "Accepter",
            "ca_canceled": "Annuler",
            "ca_rejected": "Rejeter",
            "ca_undefined": "Indéfini",
            "ca_member_address": "Adresse",
            "ca_roles": "Rôles de l'entreprise",
            "ca_create_new_role": "Créer un nouveau rôle",
            "ca_edit_role": "Modifier le rôle",
            "ca_delete_role": "Supprimer le rôle",
            "ca_cannot_edit": "Suppression impossible",
            "ca_role_name": "Nom du rôle",
            "ca_related_members": "Membres associés",
            "ca_permissions": "Autorisations",
            "ca_action_roles": "Action",
            "ca_manage_company_orders": "Gérer les commandes de l'entreprise",
            "ca_manage_roles": "Gérer les rôles",
            "ca_manage_members": "Gérer les membres",
            "ca_members_can_create_company_orders": "Par défaut, tous les membres peuvent créer des commandes d'entreprise",
            "ca_orders": "Commandes de l'entreprise",
            "ca_my_orders_page": "Mes commandes",
            "ca_id": "ID",
            "ca_created_at_order": "Créé le",
            "ca_order_name": "Nom",
            "ca_order_by": "Commandé par",
            "ca_status_order": "Statut du paiement",
            "ca_paid_order": "Payé",
            "ca_not_paid_order": "Non payé",
            "ca_subtotal_order": "Sous-total",
            "ca_note_order": "Note",
            "ca_action_order": "Action",
            "ca_order_details": "Détails de la commande",
            "ca_items_order": "Articles",
            "ca_estimated_subtotal": "Sous-total estimé",
            "ca_paid_by": "Payé par",
            "ca_confirm_payment_status": "Confirmer le statut du paiement",
            "ca_confirm_payment_content": "Confirmer le statut du paiement",
            "ca_product": "Produit",
            "ca_title_share_company": "Titre",
            "ca_total_share_company": "Total",
            "ca_subtotal_share_company": "Sous-total",
            "ca_clear_my_cart": "Vider mon panier après partage",
            "ca_your_cart": "Votre panier",
            "ca_share_your_cart": "Partager votre panier avec l'entreprise",
            "ca_note_share_company": "Note",
            "ca_your_cart_empty_share_company": "Votre panier est vide",
            "ca_appear_cart_after_sharing": "Après le partage, votre panier apparaîtra dans les commandes de l'entreprise en tant que commande",
            "sr_please_contact_the_store_owner": "VEUILLEZ CONTACTER LE PROPRIÉTAIRE DE LA BOUTIQUE. VOTRE COMPTE N'EST PAS AUTORISÉ À UTILISER UN REPRÉSENTANT COMMERCIAL.",
            "sr_sales_rep": "REPRÉSENTANT COMMERCIAL",
            "sr_sales_rep_home": "Accueil représentant commercial",
            "sr_coupon": "Coupon",
            "sr_create_invoice": "Créer une facture",
            "sr_manage_customers": "Gérer les clients",
            "sr_manage_orders": "Gérer les commandes",
            "sr_btn_create_customer": "Créer un client",
            "sr_btn_preview_and_send_invoice": "Aperçu de la facture",
            "sr_btn_preview_and_send_order": "Créer la commande",
            "sr_btn_add_to_order": "Ajouter à la commande",
            "sr_btn_view_options": "Voir les options",
            "sr_btn_preview_order": "Aperçu de la commande",
            "sr_btn_preview_order_items": "articles",
            "sr_btn_preview_order_quantities": "quantités",
            "sr_added_to_order": "Ajouté à la commande",
            "sr_home_dashboard_text": "Tableau de bord",
            "sr_home_sales_current_month_text": "Performance des ventes du mois en cours",
            "sr_home_sales_by_filter_text": "Performance des ventes par filtre",
            "sr_home_one_month_text": "1 mois",
            "sr_home_three_months_text": "3 mois",
            "sr_home_six_months_text": "6 mois",
            "sr_home_nine_months_text": "9 mois",
            "sr_home_twelve_months_text": "12 mois",
            "sr_home_total_orders_text": "Total des commandes",
            "sr_home_commission_text": "Commission",
            "sr_home_sales_text": "Ventes",
            "sr_my_customers": "Mes clients",
            "sr_share_your_discount_coupon_code": "Partagez votre code coupon de réduction avec le client !",
            "sr_your_coupon_code": "Votre code coupon :",
            "sr_discount_amount": "Montant de la réduction :",
            "sr_commission_rate": "Taux de commission :",
            "sr_based_on_specific_product": "Basé sur un produit spécifique",
            "sr_mark_order_with_customers": "Marquer la commande avec le client",
            "sr_mark_with_customers": "Marquer avec le client",
            "sr_customers_title_create": "Créer un client",
            "sr_customers_drop_down_created_at": "Créé le",
            "sr_customers_all": "Tous",
            "sr_customers_last_seven_days": "7 derniers jours",
            "sr_customers_last_thirty_days": "30 derniers jours",
            "sr_customers_last_ninety_days": "90 derniers jours",
            "sr_customers_last_twelve_months": "12 derniers mois",
            "sr_customers_my_customers": "Mes clients",
            "sr_customers_enter_customer_email": "Entrez l'e-mail du client",
            "sr_customers_no": "N°",
            "sr_customers_id": "ID CLIENT",
            "sr_customers_name": "NOM",
            "sr_customers_email_table_text": "E-MAIL",
            "sr_customers_total_commission": "COMMISSION TOTALE",
            "sr_customers_created_on": "CRÉÉ LE",
            "sr_customers_actions": "ACTIONS",
            "sr_customer_overview": "Aperçu du client",
            "sr_customers_first_name": "Prénom",
            "sr_customers_last_name": "Nom",
            "sr_customers_email": "E-mail",
            "sr_customers_create_phone_number": "Numéro de téléphone",
            "sr_customers_agreed_emails": "Le client a accepté de recevoir des e-mails marketing.",
            "sr_customers_agreed_receive_SMS": "Le client a accepté de recevoir des SMS marketing.",
            "sr_customers_permission_notice": "Vous devez demander la permission à vos clients avant de les abonner à vos e-mails ou SMS marketing.",
            "sr_customers_customer_address": "Adresse du client",
            "sr_customers_country_region": "Pays/Région",
            "sr_customers_company": "Entreprise",
            "sr_customers_address": "Adresse",
            "sr_customers_apartment_suite_etc": "Appartement, suite, etc.",
            "sr_customers_city": "Ville",
            "sr_customers_postal_code": "Code postal",
            "sr_customers_phone_number": "Numéro de téléphone",
            "sr_customers_customer_note": "Note client",
            "sr_customers_note": "Note",
            "sr_customers_checkout_notice": "*Si un client passe à la caisse avec l'un de ces e-mails, la commande sera marquée comme la vôtre (pas besoin de se connecter)",
            "sr_customers_customer": "Client",
            "sr_customers_email_lowercase": "e-mail",
            "sr_customers_created_at": "Créé le",
            "sr_customers_amount_spent": "Montant dépensé",
            "sr_customers_total_orders": "Total des commandes",
            "sr_customers_status": "Statut",
            "sr_customers_enabled_uppercase": "ACTIVÉ",
            "sr_customers_disabled_uppercase": "DÉSACTIVÉ",
            "sr_customers_declined_uppercase": "REFUSÉ",
            "sr_customers_invited_uppercase": "INVITÉ",
            "sr_customers_tags": "Étiquettes",
            "sr_customers_order": "COMMANDE",
            "sr_customers_date": "DATE",
            "sr_customers_payment": "PAIEMENT",
            "sr_customers_fulfillment": "TRAITEMENT",
            "sr_customers_subtotal": "SOUS-TOTAL",
            "sr_customers_commission": "COMMISSION",
            "sr_customers_tax": "TAXE",
            "sr_customers_total": "TOTAL",
            "sr_invoice_create_invoice_title": "Créer une facture",
            "sr_customer_info": "INFOS CLIENT",
            "sr_invoice_all": "Tous",
            "sr_invoice_last_name_required": "Le nom est obligatoire",
            "sr_invoice_city_required": "La ville est obligatoire",
            "sr_invoice_address_required": "L'adresse est obligatoire",
            "sr_invoice_country_required": "Le pays est obligatoire",
            "sr_invoice_please_select_customer": "Veuillez sélectionner un client pour créer la facture",
            "sr_invoice_customer": "Liste des clients",
            "sr_invoice_email": "E-mail",
            "sr_invoice_create_address": "Adresse",
            "sr_invoice_select_customer": "Sélectionner un client",
            "sr_invoice_customer_email": "E-mail du client",
            "sr_invoice_customer_address": "Adresse du client",
            "sr_invoice_shipping_address": "Adresse d'expédition",
            "sr_invoice_hide_shipping_address": "Masquer l'adresse d'expédition",
            "sr_invoice_show_shipping_address": "Afficher l'adresse d'expédition",
            "sr_invoice_edit_shipping_address": "Modifier l'adresse d'expédition",
            "sr_invoice_first_name": "Prénom",
            "sr_invoice_last_name": "Nom",
            "sr_invoice_address": "Adresse",
            "sr_invoice_company": "Entreprise",
            "sr_invoice_apartment_suite_etc": "Appartement, suite, etc.",
            "sr_invoice_city": "Ville",
            "sr_invoice_country": "Pays",
            "sr_invoice_postal_code": "Code postal",
            "sr_invoice_product_list": "LISTE DE PRODUITS",
            "sr_invoice_add_note": "Ajouter une note",
            "sr_no_items_in_order": "Aucun article dans la commande",
            "sr_invoice_note_to_the_order": "Note sur la commande",
            "sr_invoice_select_products": "Sélectionner des produits",
            "sr_invoice_search_product_title_SKU": "Rechercher titre produit, SKU",
            "sr_invoice_total_record": "Total des enregistrements",
            "sr_invoice_subtotal": "Sous-total",
            "sr_invoice_send_invoice": "Envoyer la facture",
            "sr_invoice_cancel": "Annuler",
            "sr_invoice_from": "De :",
            "sr_invoice_to": "À :",
            "sr_invoice_subject": "Objet :",
            "sr_invoice_success": "Succès",
            "sr_invoice_send_invoice_successfully": "Facture envoyée avec succès",
            "sr_invoice_send_invoice_failed": "Échec de l'envoi de la facture",
            "sr_invoice_send_order_successfully": "Commande envoyée avec succès",
            "sr_invoice_in_stock": "En stock",
            "sr_invoice_out_of_stock": "Rupture de stock",
            "sr_invoice_volume_pricing_available": "Tarification dégressive disponible",
            "sr_invoice_SKU": "SKU",
            "sr_invoice_commission": "Commission",
            "sr_invoice_shipping_address_updated": "Adresse d'expédition mise à jour",
            "sr_invoice_qty": "qté",
            "sr_orders_my_orders": "Mes commandes",
            "sr_orders_all_orders": "Toutes les commandes",
            "sr_orders_orders": "Commandes",
            "sr_orders_draft_orders": "Commandes brouillons",
            "sr_orders_order": "COMMANDE",
            "sr_orders_order_date": "DATE DE COMMANDE",
            "sr_orders_customer": "CLIENT",
            "sr_orders_status": "STATUT",
            "sr_orders_tracking_number": "NUMÉRO DE SUIVI",
            "sr_draft_order_open": "OUVERT",
            "sr_draft_order_invoice_sent": "FACTURE_ENVOYÉE",
            "sr_orders_table_subtotal": "TOTAL",
            "sr_orders_commission": "COMMISSION",
            "sr_orders_action": "ACTION",
            "sr_orders_invoice": "FACTURE",
            "sr_orders_select_customer": "Sélectionner un client",
            "sr_orders_order_info_customer": "Client",
            "sr_orders_not_selected": "Non sélectionné",
            "sr_orders_created_by": "Créé par",
            "sr_orders_payment_status": "Statut du paiement",
            "sr_orders_payment_paid": "PAYÉ",
            "sr_orders_payment_pending": "EN ATTENTE",
            "sr_orders_fulfillment_status": "Statut du traitement",
            "sr_orders_unfulfilled": "NON TRAITÉ",
            "sr_orders_fulfilled": "TRAITÉ",
            "sr_orders_created_at": "Créé le",
            "sr_orders_commission_rate": "Taux de commission",
            "sr_orders_tags": "Étiquettes",
            "sr_orders_tracking_number_view": "Numéro de suivi",
            "sr_orders_subtotal": "Sous-total",
            "sr_orders_discount": "Remise",
            "sr_orders_tax": "Taxe",
            "sr_orders_shipping": "Expédition",
            "sr_orders_total": "Total",
            "sr_orders_no_preview_title": "Il n'y a pas d'aperçu pour l'e-mail de confirmation de commande. Une fois envoyé, vous ne pourrez plus modifier l'e-mail.",
            "sr_orders_no_preview_subtitle_1": "Nous vous suggérons d'envoyer d'abord un e-mail de test.",
            "sr_orders_no_preview_subtitle_2": "Voulez-vous continuer ?",
            "info_heading": "INFORMATIONS",
            "info_personal_title": "Informations personnelles",
            "info_personal_information_heading": "Mes informations",
            "info_personal_b2b_information_heading": "Informations B2B",
            "info_personal_password_heading": "Changer mon mot de passe",
            "info_personal_address_heading": "Adresses",
            "info_personal_first_name_label": "Prénom",
            "info_personal_last_name_label": "Nom",
            "info_personal_email_label": "E-mail",
            "info_personal_email_consent_label": "M'envoyer des nouvelles et des offres par e-mail",
            "info_personal_password_label": "Nouveau mot de passe",
            "info_personal_repeated_password_label": "Répéter le mot de passe",
            "info_personal_company_label": "Entreprise",
            "info_personal_address1_label": "Adresse",
            "info_personal_address2_label": "Appartement, suite, etc.",
            "info_personal_city_label": "Ville",
            "info_personal_country_label": "Pays",
            "info_personal_province_label": "Province",
            "info_personal_zip_label": "Code postal",
            "info_personal_phone_label": "Téléphone",
            "info_personal_default_address_label": "Définir comme adresse par défaut",
            "info_personal_email_empty": "L'e-mail est obligatoire",
            "info_personal_email_invalid": "L'e-mail n'est pas valide",
            "info_personal_password_empty": "Le mot de passe est obligatoire",
            "info_personal_password_short": "Le mot de passe doit contenir au moins 5 caractères",
            "info_personal_repeated_password_empty": "Veuillez répéter le mot de passe",
            "info_personal_repeated_password_unmatched": "Les mots de passe ne correspondent pas",
            "info_personal_save_info": "Enregistrer les détails",
            "info_personal_save_password": "Enregistrer le mot de passe",
            "info_personal_update_address": "Mettre à jour l'adresse",
            "info_personal_add_address": "Ajouter une adresse",
            "info_personal_default_address": "Adresse par défaut",
            "info_personal_delete_address": "Supprimer l'adresse",
            "info_personal_delete_address_content": "Cette action est irréversible",
            "info_personal_phone_invalid": "Le numéro de téléphone n'est pas valide",
            "info_personal_cancel": "Annuler",
            "info_personal_edit": "Modifier",
            "info_personal_delete": "Supprimer",
            "info_orders_title": "Mes commandes",
            "nt": {
                "netterm": "CONDITIONS NETTES/ACHAT DIFFÉRÉ",
                "cart_purchase": "Achat par panier",
                "order_history": "Historique des commandes",
                "order_detail": "Détails de la commande",
                "purchase_late": "Achat différé",
                "no_items": "Aucun article dans le panier",
                "cp_checkout": "Passer à la caisse",
                "cp_shipping": "Continuer vers l'expédition",
                "cp_change": "Modifier",
                "nt_remove": "Supprimer",
                "nt_return_to_cart": "Retour au panier",
                "nt_return_to_order_history": "Retour à l'historique des commandes",
                "nt_continue": "Continuer",
                "pl_cart_subtotal": "Sous-total",
                "pl_cart_sku": "SKU",
                "pl_cart_price": "PRIX",
                "pl_cart_quantity": "QUANTITÉ",
                "pl_cart_shipping": "Expédition",
                "pl_cart_taxes": "Taxes",
                "pl_cart_total": "Total",
                "pl_cart_free": "Gratuit",
                "pl_cart_taxes_included": "Inclut {{price}} de taxes",
                "login": "CONNEXION",
                "email": "E-mail",
                "password": "Mot de passe",
                "signin": "Se connecter",
                "return_store": "Retour à la boutique",
                "forgot": "Mot de passe oublié ?",
                "create": "Créer un compte",
                "contact_information": "COORDONNÉES",
                "cp_email": "E-mail",
                "log_out": "Se déconnecter",
                "shipping_address": "ADRESSE D'EXPÉDITION",
                "billing_address": "ADRESSE DE FACTURATION",
                "use_ship_address_as_bill_address": "Utiliser l'adresse d'expédition comme adresse de facturation",
                "new_address": "Utiliser une nouvelle adresse",
                "first_name": "Prénom (facultatif)",
                "last_name": "Nom",
                "company": "Entreprise (facultatif)",
                "address": "Adresse",
                "apartment": "Appartement, suite, etc. (facultatif)",
                "city": "Ville",
                "postal_code": "Code postal",
                "personal_customs_code": "Code de douane personnel",
                "nt_cart_note": "Note de panier",
                "required": "Ce champ est obligatoire",
                "invalidEmail": "Veuillez entrer une adresse e-mail valide",
                "alert": "VEUILLEZ CONTACTER LE PROPRIÉTAIRE DE LA BOUTIQUE. VOTRE COMPTE N'EST PAS AUTORISÉ À EFFECTUER DES ACHATS DIFFÉRÉS.",
                "errorMessage": "Remplissez tous les champs obligatoires et vérifiez les erreurs",
                "due_on": "Votre paiement est dû le",
                "additional_information": "INFORMATIONS COMPLÉMENTAIRES",
                "nt_valid_eu_vat": "NUMÉRO DE TVA UE VALIDE",
                "nt_valid_abn": "NUMÉRO ABN VALIDE",
                "nt_valid_gst": "NUMÉRO GST INDE VALIDE",
                "nt_valid_uk": "NUMÉRO DE TVA UK VALIDE",
                "nt_invalid_eu_vat": "La TVA UE n'est pas valide. Veuillez la ressaisir",
                "nt_invalid_abn": "L'ABN n'est pas valide. Veuillez le ressaisir",
                "nt_invalid_gst": "Le numéro GST n'est pas valide. Veuillez le ressaisir",
                "nt_invalid_uk": "Le numéro de TVA UK n'est pas valide. Veuillez le ressaisir",
                "nt_invalid_postal_code": "Entrez un code postal valide",
                "pl_shipping_contact": "Contact",
                "pl_shipping_shipto": "Expédier à",
                "pl_shipping_method": "MODE D'EXPÉDITION",
                "pl_shipping_error_heading": "Aucun tarif d'expédition trouvé pour cette adresse.",
                "pl_shipping_error_message": "Cette commande ne peut pas être expédiée à l'adresse indiquée. Vérifiez votre adresse pour vous assurer que tous les champs ont été saisis correctement et réessayez.",
                "purchase_late_note": "NOTE D'ACHAT DIFFÉRÉ",
                "purchase_late_message": "Le(s) produit(s) ci-dessus ne sont pas éligibles pour l'achat différé. Ils seront supprimés si vous cliquez sur le bouton Achat différé.",
                "purchase_late_link": "Accéder à la page d'achat différé",
                "nt_out_of_stock_title": "Rupture de stock",
                "nt_out_of_stock_describe": "Certains articles ne sont plus disponibles. Votre panier a été mis à jour.",
                "nt_out_of_stock_sold_out": "Épuisé",
                "ot_name": "Nom",
                "ot_email": "E-mail",
                "ot_shipping": "Expédition",
                "ot_rule": "Règle",
                "ot_date": "Date de commande",
                "ot_netterms": "Conditions nettes",
                "ot_remaining_days": "Jours restants",
                "ot_days": "jour(s)",
                "ot_hours": "heure(s)",
                "ot_due_on_receipt": "Dû à la réception",
                "ot_due_on_date": "Dû à une date spécifique",
                "pl_cart_product": "PRODUIT",
                "nt_edit": "Modifier",
                "nt_cancel": "Annuler",
                "nt_save": "Enregistrer",
                "nt_stay": "Rester",
                "nt_search_input": "Entrer le nom de la commande",
                "nt_search_btn": "Rechercher",
                "nt_sort_by": "Trier par",
                "nt_new_to_old": "Du plus récent au plus ancien",
                "nt_old_to_new": "Du plus ancien au plus récent",
                "nt_a_to_z": "Nom A-Z",
                "nt_z_to_a": "Nom Z-A",
                "nt_short_to_long": "Conditions nettes : du plus court au plus long",
                "nt_long_to_short": "Conditions nettes : du plus long au plus court",
                "nt_remain_days_asc": "Jours restants croissants",
                "nt_remain_days_desc": "Jours restants décroissants",
                "nt_save_to_calculate": "Enregistrer pour calculer",
                "nt_empty_cart": "Votre panier est vide",
                "nt_checkout_unsaved_changes": "Passer à la caisse avec des modifications non enregistrées ?",
                "nt_checkout_saving_current_edits": "Si vous cliquez sur Passer à la caisse, vous procéderez avec votre panier précédent sans enregistrer les modifications actuelles.",
                "nt_continue_shipping": "Continuer vers l'expédition avec des modifications non enregistrées ?",
                "nt_shipping_saving_current_edits": "Si vous cliquez sur Continuer vers l'expédition, vous procéderez avec votre panier précédent sans enregistrer les modifications actuelles.",
                "restrict_value_greater": "La valeur totale de votre panier doit être supérieure ou égale à {{value}}",
                "restrict_value_less": "La valeur totale de votre panier doit être inférieure ou égale à {{value}}",
                "restrict_quantity_greater": "La quantité d'articles dans votre panier doit être supérieure ou égale à {{value}}",
                "restrict_quantity_less": "La quantité d'articles dans votre panier doit être inférieure ou égale à {{value}}",
                "order_detail_no_detail": "Échec de la récupération des détails de la commande",
                "due_on_payment": "Dû au paiement"
            },
            "qo": {
                "quick_order_navigation_menu": "COMMANDE RAPIDE",
                "quick_order_list": "Liste de produits",
                "quick_order_cart": "Aperçu du panier",
                "go_to_cart": "Aller au panier",
                "checkout_btn": "Passer à la caisse",
                "sync_with_cart": "SYNCHRONISER AVEC LE PANIER",
                "sync_with_cart_banner_info": "Cliquez sur « SYNCHRONISER AVEC LE PANIER » pour que votre aperçu et votre panier soient parfaitement alignés. Ne perdez plus jamais le fil de vos articles !",
                "add_to_cart": "Ajouter au panier",
                "contact_msg": "Veuillez contacter le propriétaire de la boutique : votre compte n'est pas autorisé pour les commandes rapides.",
                "failed_msg": "Impossible de trouver le(s) produit(s)",
                "total_record": "Total des enregistrements",
                "sku": "SKU",
                "barcode": "Code-barres",
                "subtotal": "Sous-total",
                "search_product_title_sku": "Rechercher par titre de produit, SKU",
                "all": "Tous",
                "title_az": "Titre A-Z",
                "title_za": "Titre Z-A",
                "newest_created_date": "Date de création la plus récente",
                "oldest_created_date": "Date de création la plus ancienne",
                "inventory_quantity_lowest_to_highest": "Quantité en stock croissante",
                "inventory_quantity_highest_to_lowest": "Quantité en stock décroissante",
                "price_lowest_to_highest": "Prix croissant",
                "price_highest_to_lowest": "Prix décroissant",
                "qo_loading_type": "Charger plus",
                "end_of_list": "Vous avez atteint la fin de la liste.",
                "add_all": "Ajouter {{items}} articles au panier",
                "remove_all": "Supprimer tous les articles",
                "sort_collection": "Collection",
                "from": "À partir de",
                "view_option": "Voir les options",
                "in_stock": "En stock",
                "out_of_stock": "Rupture de stock",
                "price_cut": "RÉDUCTION",
                "save_discount": "ÉCONOMISER",
                "popup_added_to_cart": "Ajouté au panier",
                "volume_pricing_available": "Tarification dégressive disponible",
                "no_line_items_cart": "Votre panier est vide !",
                "add_to_cart_error": "Une erreur inattendue s'est produite. Veuillez réessayer",
                "cart_items": "articles",
                "cart_quantities": "quantités",
                "synced_with_cart_toast": "Synchronisé avec le panier",
                "product_types": "TYPES DE PRODUITS",
                "collections": "COLLECTIONS"
            }
        }
	};
}
